import ge, { useReducer as Ae, useCallback as B, useEffect as W, useState as U, memo as fe, createElement as Jt, useMemo as K, useContext as Rt, createContext as Nn } from "react";
import { Autocomplete as Fe, Box as F, Checkbox as re, Divider as qe, Chip as en, Grid as _, styled as jn, MuiTooltip as yn, tooltipClasses as Dn, NewTable as Ue, lighten as An, Skeleton as Lt, Tooltip as be, DropDownMenu as Pn, darken as Ft, Icon as te, Typography as se, StatusTag as tn, CheckboxCell as vn, SelectAllHeaderCell as wn, ContentBlock as Ee, Select as nn, Block as Qe, Alert as ut, IconActionButton as _e, IconActionButtonFilled as pt, Spinner as Ct, Modal as We, useNotifications as ht, Input as Ot, Button as ae, IconButton as ft, Switch as sn, Paper as je, FilterPanel as Ke, ModalTitle as bt, InputFilter as Et, AISpinner as kn, Count as Ln } from "@prometheus/components";
import { useRequest as Nt, useSelectedConcepts as xe, useDomains as Fn, useFilters as Ut, ModalContext as on, useFilterOptions as Un } from "@prometheus/hooks";
import { api as Z, getSortDirection as jt, getReducerWithProduce as Pe, parseFiltersToStringParams as St, convertConceptModelToExtendConcept as ve, formatFilterListNoFiql as Xe, keyBy as Ne, getStandartConceptType as at, isEqual as Me, getCookie as Mn, eraseCookie as zn, setCookie as Gn, formatNumber as et, getUUID as yt, groupBy as Be, convertExtendedToFlatConcepts as an, convertExtendedConceptsToMap as Hn, convertLegacyFlatNewConceptsToExtended as Mt, normalizeAndFilterConcepts as Te, separateSearchFilters as Ze, parseUrlSearchParamsToObject as zt, cleanupSearchParamsObject as $n, rekeyById as Tt, parseConceptsBySourceCodes as rn, parseConceptsById as Bn, debounce as Vn, downloadFile as Qn, isValidHttpUrl as Gt } from "@prometheus/utils";
import { Status as m, AiSuggestionStatus as Ye } from "@prometheus/types";
import { StandardConceptTypes as me, mapStandardConceptTypes as rt, TypesOfContainer as ye, containerTypes as Wn, TypeOfImportConcepts as ze, TypesOfRelatedConcepts as Ht, VocabularyConceptTabs as De, ImportConceptsTabs as Se, TypesOfIncluded as Ve } from "@prometheus/enums";
import { useLocalStorage as cn, TitleWithCount as Le, SpinnerWidgetContainer as Dt, InfoIcon as At, ListHeaderPrimary as Yn, FloatingButton as Pt, IconButton as ln, TabsNavigationNew as dn, CodeEditor as qn, FileContentType as Kn, Count as Xn, FormElement as tt } from "@prometheus/features";
import Q from "@emotion/styled";
import { useSelector as vt, useDispatch as Zn } from "react-redux";
import { useSearchParams as Jn, Outlet as es, useNavigate as Ge, useLocation as Je, useParams as ts, Link as ns, Routes as un, Route as ot } from "react-router-dom";
import { setBreadcrumbs as ss } from "@prometheus/redux";
var It = { exports: {} }, He = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $t;
function os() {
  if ($t) return He;
  $t = 1;
  var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
  function s(a, r, d) {
    var C = null;
    if (d !== void 0 && (C = "" + d), r.key !== void 0 && (C = "" + r.key), "key" in r) {
      d = {};
      for (var h in r)
        h !== "key" && (d[h] = r[h]);
    } else d = r;
    return r = d.ref, {
      $$typeof: t,
      type: a,
      key: C,
      ref: r !== void 0 ? r : null,
      props: d
    };
  }
  return He.Fragment = n, He.jsx = s, He.jsxs = s, He;
}
var $e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bt;
function as() {
  return Bt || (Bt = 1, process.env.NODE_ENV !== "production" && function() {
    function t(S) {
      if (S == null) return null;
      if (typeof S == "function")
        return S.$$typeof === y ? null : S.displayName || S.name || null;
      if (typeof S == "string") return S;
      switch (S) {
        case x:
          return "Fragment";
        case O:
          return "Profiler";
        case p:
          return "StrictMode";
        case b:
          return "Suspense";
        case P:
          return "SuspenseList";
        case R:
          return "Activity";
      }
      if (typeof S == "object")
        switch (typeof S.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), S.$$typeof) {
          case T:
            return "Portal";
          case A:
            return (S.displayName || "Context") + ".Provider";
          case N:
            return (S._context.displayName || "Context") + ".Consumer";
          case j:
            var g = S.render;
            return S = S.displayName, S || (S = g.displayName || g.name || "", S = S !== "" ? "ForwardRef(" + S + ")" : "ForwardRef"), S;
          case f:
            return g = S.displayName || null, g !== null ? g : t(S.type) || "Memo";
          case I:
            g = S._payload, S = S._init;
            try {
              return t(S(g));
            } catch {
            }
        }
      return null;
    }
    function n(S) {
      return "" + S;
    }
    function s(S) {
      try {
        n(S);
        var g = !1;
      } catch {
        g = !0;
      }
      if (g) {
        g = console;
        var w = g.error, G = typeof Symbol == "function" && Symbol.toStringTag && S[Symbol.toStringTag] || S.constructor.name || "Object";
        return w.call(
          g,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          G
        ), n(S);
      }
    }
    function a(S) {
      if (S === x) return "<>";
      if (typeof S == "object" && S !== null && S.$$typeof === I)
        return "<...>";
      try {
        var g = t(S);
        return g ? "<" + g + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var S = z.A;
      return S === null ? null : S.getOwner();
    }
    function d() {
      return Error("react-stack-top-frame");
    }
    function C(S) {
      if (k.call(S, "key")) {
        var g = Object.getOwnPropertyDescriptor(S, "key").get;
        if (g && g.isReactWarning) return !1;
      }
      return S.key !== void 0;
    }
    function h(S, g) {
      function w() {
        oe || (oe = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          g
        ));
      }
      w.isReactWarning = !0, Object.defineProperty(S, "key", {
        get: w,
        configurable: !0
      });
    }
    function l() {
      var S = t(this.type);
      return ce[S] || (ce[S] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), S = this.props.ref, S !== void 0 ? S : null;
    }
    function i(S, g, w, G, M, q, pe, Ie) {
      return w = q.ref, S = {
        $$typeof: E,
        type: S,
        key: g,
        props: q,
        _owner: M
      }, (w !== void 0 ? w : null) !== null ? Object.defineProperty(S, "ref", {
        enumerable: !1,
        get: l
      }) : Object.defineProperty(S, "ref", { enumerable: !1, value: null }), S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(S, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(S, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: pe
      }), Object.defineProperty(S, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ie
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    }
    function c(S, g, w, G, M, q, pe, Ie) {
      var X = g.children;
      if (X !== void 0)
        if (G)
          if ($(X)) {
            for (G = 0; G < X.length; G++)
              u(X[G]);
            Object.freeze && Object.freeze(X);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else u(X);
      if (k.call(g, "key")) {
        X = t(S);
        var Ce = Object.keys(g).filter(function(we) {
          return we !== "key";
        });
        G = 0 < Ce.length ? "{key: someKey, " + Ce.join(": ..., ") + ": ...}" : "{key: someKey}", v[X + G] || (Ce = 0 < Ce.length ? "{" + Ce.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          G,
          X,
          Ce,
          X
        ), v[X + G] = !0);
      }
      if (X = null, w !== void 0 && (s(w), X = "" + w), C(g) && (s(g.key), X = "" + g.key), "key" in g) {
        w = {};
        for (var Re in g)
          Re !== "key" && (w[Re] = g[Re]);
      } else w = g;
      return X && h(
        w,
        typeof S == "function" ? S.displayName || S.name || "Unknown" : S
      ), i(
        S,
        X,
        q,
        M,
        r(),
        w,
        pe,
        Ie
      );
    }
    function u(S) {
      typeof S == "object" && S !== null && S.$$typeof === E && S._store && (S._store.validated = 1);
    }
    var o = ge, E = Symbol.for("react.transitional.element"), T = Symbol.for("react.portal"), x = Symbol.for("react.fragment"), p = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), N = Symbol.for("react.consumer"), A = Symbol.for("react.context"), j = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), I = Symbol.for("react.lazy"), R = Symbol.for("react.activity"), y = Symbol.for("react.client.reference"), z = o.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, k = Object.prototype.hasOwnProperty, $ = Array.isArray, Y = console.createTask ? console.createTask : function() {
      return null;
    };
    o = {
      react_stack_bottom_frame: function(S) {
        return S();
      }
    };
    var oe, ce = {}, le = o.react_stack_bottom_frame.bind(
      o,
      d
    )(), D = Y(a(d)), v = {};
    $e.Fragment = x, $e.jsx = function(S, g, w, G, M) {
      var q = 1e4 > z.recentlyCreatedOwnerStacks++;
      return c(
        S,
        g,
        w,
        !1,
        G,
        M,
        q ? Error("react-stack-top-frame") : le,
        q ? Y(a(S)) : D
      );
    }, $e.jsxs = function(S, g, w, G, M) {
      var q = 1e4 > z.recentlyCreatedOwnerStacks++;
      return c(
        S,
        g,
        w,
        !0,
        G,
        M,
        q ? Error("react-stack-top-frame") : le,
        q ? Y(a(S)) : D
      );
    };
  }()), $e;
}
process.env.NODE_ENV === "production" ? It.exports = os() : It.exports = as();
var e = It.exports;
const rs = (t) => {
  const { pageNumber: n, pageSize: s, sortBy: a, query: r } = t, d = jt(a), C = `/concepts/list?${r}&size=${s || ""}&page=${n || ""}&sort=${d}`;
  return Z.get(C);
}, cs = (t, n = !1, s, a) => {
  const { pageNumber: r, pageSize: d, sortBy: C, query: h } = a, l = jt(C), c = (n ? `/concepts/concept/${s}/non-standard/${t}/list` : `/concepts/concept/${s}/${t}`) + `?size=${d || ""}&page=${r || ""}&sort=${l}&${h || ""}`;
  return Z.get(c);
}, ls = (t) => {
  const n = `/concepts/filter?${t}`;
  return Z.get(n);
}, is = (t, n) => (s) => {
  const r = `/concepts/concept/${t}/${n ? "non-standard/" : ""}ancestors/filter?${s}`;
  return Z.get(r);
}, ds = (t, n) => (s) => {
  const r = `/concepts/concept/${t}/${n ? "non-standard/" : ""}descendants/filter?${s}`;
  return Z.get(r);
}, pn = (t) => Z.post("/concepts/lookup/identifiers?size=1000000", t), Cn = (t) => Z.post("/concepts/lookup/sourcecodes?size=1000000", t), us = (t) => Z.get(`/concepts/concept/${t}`), ps = (t, n, s) => {
  const a = s ? `sort=${jt(s)}` : "";
  return Z.get(
    `/concepts/${t}/related/list?${a}${n ? "&" + n : ""}`
  );
}, hn = (t) => Z.post("/concepts", t || []), Cs = (t) => (n) => Z.get(`/concepts/${t}/related/filter?${n}`), hs = () => Z.get("/concepts/vocabulary-version"), Es = () => Z.get("/data-sources/with-record-counts"), Ss = (t) => Z.get(`/data-sources/default/${t}`), ms = (t, n) => Z.post(`/conceptset/suggestion/${t}`, n), xs = (t, n) => Z.post(
  `/conceptset/suggestion/${t}/list`,
  {}
);
var ee = /* @__PURE__ */ ((t) => (t.UPDATE_PAGE_NUMBER = "UPDATE_PAGE_NUMBER", t.UPDATE_QUERY = "UPDATE_QUERY", t.UPDATE_ADVANCED_SEARCH = "UPDATE_ADVANCED_SEARCH", t.UPDATE_FILTERS = "UPDATE_FILTERS", t.RESET_FILTERS = "RESET_FILTERS", t.SEARCH_REQUEST = "SEARCH_REQUEST", t.SEARCH_REQUEST_DONE = "SEARCH_REQUEST_DONE", t.SEARCH_REQUEST_FAILED = "SEARCH_REQUEST_FAILED", t.CLEAR_SEARCH = "CLEAR_SEARCH", t.UPDATE_SEARCH_PARAMS = "UPDATE_SEARCH_PARAMS", t.SAVE_SETTINGS = "SAVE_SETTINGS", t.SET_SIZE = "SET_SIZE", t))(ee || {});
const _s = (t, n) => Pe(t, (s) => {
  var a, r, d;
  switch (n.type) {
    case ee.UPDATE_QUERY:
      s.searchParams.searchQuery = n.payload;
      break;
    case ee.UPDATE_ADVANCED_SEARCH:
      s.searchParams.advancedSearch = n.payload;
      break;
    case ee.UPDATE_FILTERS:
      s.searchParams.searchFilters = {
        ...s.searchParams.searchFilters,
        ...n.payload
      };
      break;
    case ee.RESET_FILTERS: {
      s.searchParams.searchFilters = {};
      break;
    }
    case ee.UPDATE_SEARCH_PARAMS:
      s.searchParams = {
        searchQuery: (a = n.payload.fullSearch) == null ? void 0 : a[0],
        advancedSearch: (r = n.payload.advancedSearch) == null ? void 0 : r[0],
        searchFilters: n.payload,
        pageNumber: ((d = n.payload.pageNumber) == null ? void 0 : d[0]) || 0
      };
      break;
    case ee.SEARCH_REQUEST:
      s.status = s.status === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD;
      break;
    case ee.SEARCH_REQUEST_DONE:
      s.status = m.SUCCESS;
      const { data: C, filters: h } = n.payload;
      s.filters = h, s.searchData = C.content, s.pageCount = C.totalPages || 1, s.numberOfElements = C.numberOfElements, s.totalElements = C.totalElements;
      break;
    case ee.SEARCH_REQUEST_FAILED:
      s.status = m.ERROR;
      break;
    case ee.CLEAR_SEARCH:
      s.searchParams.searchQuery = "", s.searchParams.searchFilters = null, s.searchParams.pageNumber = 0, s.searchData = [], s.pageCount = 1, s.pageSize = 10, s.numberOfElements = 0, s.totalElements = 0, s.status = m.INITIAL;
      break;
    case ee.SAVE_SETTINGS:
      s.pageSize = n.payload.pageSize, s.searchParams.searchFilters = n.payload.filters;
      break;
  }
}), Vt = {
  searchParams: {
    advancedSearch: !1,
    searchQuery: "",
    searchFilters: {},
    pageNumber: 0
  },
  searchData: [],
  pageCount: 1,
  pageSize: 10,
  numberOfElements: 0,
  totalElements: 0,
  status: m.INITIAL,
  filters: []
}, wt = (t, n, s, a) => {
  const [r, d] = Ae(_s, {
    ...Vt,
    searchParams: {
      ...Vt.searchParams,
      searchFilters: a == null ? void 0 : a.filters,
      advancedSearch: a == null ? void 0 : a.advancedSearch
    },
    pageSize: a == null ? void 0 : a.pageSize
  }), C = (o) => {
    d({
      type: ee.UPDATE_QUERY,
      payload: o
    });
  }, h = (o) => {
    d({
      type: ee.UPDATE_ADVANCED_SEARCH,
      payload: o
    });
  }, l = (o) => {
    d({
      type: ee.UPDATE_FILTERS,
      payload: o
    });
  }, i = () => {
    d({
      type: ee.RESET_FILTERS
    });
  }, c = (o) => {
    d({
      type: ee.UPDATE_SEARCH_PARAMS,
      payload: o
    });
  }, u = B(
    async (o = r.searchParams.pageNumber, E = r.pageSize, T, x = !1) => {
      x || d({ type: ee.SEARCH_REQUEST });
      try {
        const { searchFilters: p, advancedSearch: O, searchQuery: N } = r.searchParams, A = St({
          ...p,
          ...N != null && {
            [O ? "advancedSearch" : "fullSearch"]: [N]
          }
        }), [j, b] = await Promise.all([
          rs({
            query: A,
            pageNumber: o,
            pageSize: E,
            sortBy: T
          }).then((P) => ({
            ...P,
            content: P.content.map(
              (f) => ve(f)
            )
          })),
          t || x ? Promise.resolve([]) : ls(A).then(Xe)
        ]);
        if (x)
          return Ne(j.content, "conceptId");
        d({
          type: ee.SEARCH_REQUEST_DONE,
          payload: { data: j, filters: b }
        });
      } catch (p) {
        console.error(p), d({
          type: ee.SEARCH_REQUEST_FAILED
        });
      }
    },
    [r.searchParams]
  );
  return W(() => {
    n != null && n != "" && l({ "filter.domain": [n] });
  }, [n]), W(() => {
    s != null && s != "" && l({ "filter.standard.concept": [s] });
  }, [s]), {
    ...r,
    search: u,
    updateQuery: C,
    updateFilters: l,
    updateSearchParams: c,
    resetFilters: i,
    updateAdvancedSearch: h
  };
}, gs = ({
  onAdd: t,
  domainId: n,
  standard: s,
  // TODO
  value: a,
  placeholder: r,
  showSelectAll: d = !0
}) => {
  const [C, h] = U(!1), { searchData: l, search: i, status: c } = wt(!0, n, null, {
    filters: {
      "filter.standard.concept": ["Standard"],
      "filter.domain": [n]
    }
  });
  W(() => {
    i(0, 1e4, null);
  }, []), W(() => {
    h(
      d && (a == null ? void 0 : a.length) !== 0 && (a == null ? void 0 : a.length) === (l == null ? void 0 : l.length)
    );
  }, [d, a, l]);
  const u = (x) => {
    x.preventDefault(), t(C ? [] : l.map((p) => p.concept));
  }, o = (x) => (x == null ? void 0 : x.value) === "selectAll", E = l.map((x) => x.concept).sort((x, p) => (x.CONCEPT_NAME || "").localeCompare(p.CONCEPT_NAME || "")), T = d ? [{ name: "Select all", value: "selectAll" }, ...E] : E;
  return /* @__PURE__ */ e.jsx(
    Fe,
    {
      fullWidth: !0,
      multiple: !0,
      options: T,
      value: a,
      isOptionEqualToValue: (x, p) => x.CONCEPT_ID === p.CONCEPT_ID,
      placeholder: r || "Select concept or enter concept name...",
      onChange: function(x, p) {
        if (p.some(o)) {
          u(x);
          return;
        }
        t(p);
      },
      getOptionLabel: function(x) {
        return x.CONCEPT_NAME || x.name;
      },
      limitTags: 50,
      disableCloseOnSelect: !0,
      loading: c === m.IN_PROGRESS || c === m.IN_PROGRESS_RELOAD,
      renderValue: (x, p) => /* @__PURE__ */ e.jsx(en, { label: x.CONCEPT_NAME || x.name, ...p() }),
      OptionComponent: (x, p, { selected: O }) => {
        var N;
        return [
          /* @__PURE__ */ e.jsxs(
            F,
            {
              ...x,
              sx: { fontSize: 13, height: "28px" },
              onClick: d && o(p) ? u : x.onClick,
              children: [
                /* @__PURE__ */ e.jsx(
                  re,
                  {
                    sx: { mr: 1 },
                    checked: d && o(p) ? C : O,
                    size: "small"
                  }
                ),
                ((N = p.concept) == null ? void 0 : N.CONCEPT_NAME) || p.CONCEPT_NAME || p.name
              ]
            }
          ),
          d && o(p) ? /* @__PURE__ */ e.jsx(qe, {}, "divider") : ""
        ];
      }
    }
  );
}, fs = {
  DOMAIN_ID_TITLE: "Domain",
  CONCEPT_CLASS_ID_TITLE: "Class",
  VOCABULARY_ID_TITLE: "Vocabulary",
  CONCEPT_ID_TITLE: "Id",
  CONCEPT_CODE_TITLE: "Code",
  INVALID_REASON_CAPTION_TITLE: "Invalid reason",
  EXCLUDE_TITLE: "Exclude",
  MAPPED_TITLE: "Mapped",
  DESCENDANTS_TITLE: "Descendants",
  HIERARCHY_TITLE: "Hierarchy"
}, Ts = Q.div`
border-top: 1px solid #e3e3e3;
    padding: 15px 15px 0px;
    background: #ffffff;
    padding-top: 15px;

.details-item-extra-margin {
    margin-bottom:20px !important;
}

.details-item-action {
    margin-bottom: 2px !important;
    label {
        margin-left: 10px;
        display: inline-block !important;
    }
}

.details-item {
    font-size: 12px;
    margin-bottom: 10px;
    color: #323232;

    label {
        color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
        font-weight: 700;
        width: 130px;
        display: block;
    }
    

    span {
        display: inline-block;
    }
}

    h3 {
        margin: 0;
        margin-bottom: 5px;
        font-size: 16px;
    }

    .header-info {
        margin-bottom: 20px;
    }

    .details-ids {
        margin-right: 10px;
        margin-bottom: 20px;
        font-size: 14px;
        label {
            font-weight: 700;
        }
        p {
            margin: 0
            margin-top:5px;
        }
    }

    .action-info {
        font-size: 14px;
        margin-right: 10px;
    }

`, Is = fe((t) => {
  const { concept: n, onEditAction: s, clearConceptSettings: a, canEdit: r } = t, [d, C] = U(n), {
    concept: {
      CONCEPT_ID: h,
      CONCEPT_CODE: l,
      CONCEPT_CLASS_ID: i,
      VOCABULARY_ID: c,
      DOMAIN_ID: u,
      INVALID_REASON_CAPTION: o,
      STANDARD_CONCEPT_CAPTION: E
    },
    excluded: T,
    descendants: x,
    mapped: p,
    hierarchy: O
  } = d, {
    CONCEPT_ID_TITLE: N,
    CONCEPT_CODE_TITLE: A,
    CONCEPT_CLASS_ID_TITLE: j,
    DOMAIN_ID_TITLE: b,
    VOCABULARY_ID_TITLE: P,
    INVALID_REASON_CAPTION_TITLE: f,
    EXCLUDE_TITLE: I,
    DESCENDANTS_TITLE: R,
    MAPPED_TITLE: y,
    HIERARCHY_TITLE: z
  } = fs;
  W(() => {
    a && C(n);
  }, [a]), W(() => {
    n.conceptId !== h && C(n);
  }, [n]);
  const k = ($) => {
    const Y = {
      ...d,
      [$]: !d[$]
    };
    C(Y), s(Y);
  };
  return /* @__PURE__ */ e.jsx(Ts, { children: /* @__PURE__ */ e.jsxs(_, { container: !0, children: [
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 9, children: /* @__PURE__ */ e.jsxs(_, { container: !0, children: [
      /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 4, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: N }),
          /* @__PURE__ */ e.jsx("span", { children: h })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: A }),
          /* @__PURE__ */ e.jsx("span", { children: l })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 4, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: b }),
          /* @__PURE__ */ e.jsx("span", { children: u })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: P }),
          /* @__PURE__ */ e.jsx("span", { children: c })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 4, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: f }),
          /* @__PURE__ */ e.jsx("span", { children: o })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: j }),
          /* @__PURE__ */ e.jsx("span", { children: i })
        ] })
      ] })
    ] }) }),
    r && /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 3, children: [
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            name: "excluded",
            checked: T,
            onChange: () => k("excluded")
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: I })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            name: "descendants",
            checked: x,
            onChange: () => k("descendants"),
            disabled: E === me.NON_STANDARD_CAPTION
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: R })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            name: "mapped",
            checked: p,
            onChange: () => k("mapped"),
            disabled: E === me.NON_STANDARD_CAPTION
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: y })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            name: "hierarchy",
            checked: O,
            onChange: () => k("hierarchy"),
            disabled: E === me.STANDARD_CAPTION
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: z })
      ] })
    ] })
  ] }) });
}), Rs = (t) => Z.post("/conceptset/optimize", t), Os = (t) => Z.post("/concepts/related-standard", t), bs = (t) => Z.post("/workspace/concept-sets", t), Ns = (t, n) => Z.post(`/studies/${t}/concept-sets`, n), ct = (t = "select") => ({
  header: "",
  id: t,
  size: 40,
  maxSize: 40,
  enableResizing: !1,
  enableSorting: !1,
  enableHiding: !1,
  meta: {
    columnType: "action",
    align: "left",
    headerAlign: "left"
  }
}), lt = (t) => ({
  header: "Id",
  id: t,
  enableColumnFilter: !1,
  enableSorting: !1,
  size: 100,
  enableHiding: !1
}), it = (t) => ({
  header: "Code",
  id: t,
  size: 100,
  enableColumnFilter: !1,
  enableSorting: !1
}), dt = (t) => ({
  header: "Name",
  id: t,
  size: 300,
  minSize: 120,
  sortingFn: "custom",
  enableSorting: !1
}), En = {
  header: "",
  id: "arrow",
  enableResizing: !1,
  enableColumnFilter: !1,
  enableHiding: !1,
  enableSorting: !1,
  size: 30,
  meta: {
    align: "center"
  }
}, js = [
  {
    header: "Non-Standard",
    enableHiding: !1,
    id: "non-standard",
    columns: [
      ct("actions"),
      lt("conceptId___non-standard"),
      it("conceptCode___non-standard"),
      dt("conceptName___non-standard"),
      En
    ]
  },
  {
    header: "Standard",
    id: "standard",
    enableHiding: !1,
    columns: [
      ct(),
      lt("conceptId___standard"),
      it("conceptCode___standard"),
      dt("conceptName___standard")
    ]
  }
], ys = jn(({ className: t, ...n }) => /* @__PURE__ */ e.jsx(yn, { width: "auto", classes: { popper: t }, ...n }))({
  [`& .${Dn.tooltip}`]: {
    maxWidth: "500px"
  }
}), Ds = ({
  to: t,
  from: n,
  children: s
}) => /* @__PURE__ */ e.jsx(
  ys,
  {
    title: n ? /* @__PURE__ */ e.jsxs(_, { container: !0, width: t ? 440 : 300, alignItems: "flex-end", children: [
      /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, display: "flex", children: [
        /* @__PURE__ */ e.jsx(
          Qt,
          {
            width: t ? "calc(100% - 20px)" : "100%",
            concept: n
          }
        ),
        t && [
          /* @__PURE__ */ e.jsx(_, { item: !0, width: "40px", margin: "auto 0", px: 0.5 }),
          /* @__PURE__ */ e.jsx(Qt, { width: "calc(100% - 20px)", concept: t })
        ]
      ] }),
      /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, display: "flex", children: [
        /* @__PURE__ */ e.jsx(_, { item: !0, width: "calc(100% - 20px)", children: /* @__PURE__ */ e.jsx(Wt, { concept: n }) }),
        t && [
          /* @__PURE__ */ e.jsx(_, { item: !0, width: "40px", margin: "auto 0", px: 0.5, children: "→" }),
          /* @__PURE__ */ e.jsx(_, { item: !0, width: "calc(100% - 20px)", children: /* @__PURE__ */ e.jsx(Wt, { concept: t }) })
        ]
      ] })
    ] }) : "",
    followCursor: !0,
    children: s
  }
), Qt = ({
  concept: t,
  width: n
}) => {
  const s = at(t == null ? void 0 : t.STANDARD_CONCEPT);
  return /* @__PURE__ */ e.jsxs(
    _,
    {
      item: !0,
      width: n,
      sx: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #ffffff80",
        pb: 1,
        mb: 1,
        alignItems: "baseline"
      },
      children: [
        /* @__PURE__ */ e.jsx(F, { fontSize: 13, children: /* @__PURE__ */ e.jsx("b", { children: t == null ? void 0 : t.CONCEPT_NAME }) }),
        /* @__PURE__ */ e.jsx(
          F,
          {
            component: "span",
            sx: {
              bgcolor: s.color,
              px: 0.5,
              py: 0.25,
              borderRadius: 0.5,
              whiteSpace: "nowrap"
            },
            children: s == null ? void 0 : s.caption
          }
        )
      ]
    }
  );
}, Wt = ({ concept: t }) => /* @__PURE__ */ e.jsxs(_, { container: !0, fontSize: 12, spacing: 0.5, children: [
  /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(F, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Id:" }) }),
    /* @__PURE__ */ e.jsx(F, { component: "span", children: t == null ? void 0 : t.CONCEPT_ID })
  ] }),
  /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(F, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Code:" }) }),
    /* @__PURE__ */ e.jsx(F, { component: "span", children: t == null ? void 0 : t.CONCEPT_CODE })
  ] }),
  /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(F, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Class:" }) }),
    /* @__PURE__ */ e.jsx(F, { component: "span", children: t == null ? void 0 : t.CONCEPT_CLASS_ID })
  ] }),
  /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(F, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Domain:" }) }),
    /* @__PURE__ */ e.jsx(F, { component: "span", children: t == null ? void 0 : t.DOMAIN_ID })
  ] }),
  /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(F, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Vocabulary:" }) }),
    /* @__PURE__ */ e.jsx(F, { component: "span", children: t == null ? void 0 : t.VOCABULARY_ID })
  ] })
] }), ne = (t) => /* @__PURE__ */ e.jsx(Ds, { from: t.row, children: /* @__PURE__ */ e.jsx(As, { styles: { ...t.styles }, className: "td", ...t, children: t.children }) }), As = Q("td")(({ styles: t }) => ({
  ...t
})), xt = ({
  selectedRows: t,
  data: n,
  setSelectedRows: s,
  setActiveRow: a,
  activeRow: r
}) => {
  const d = (i) => {
    const c = {
      [i.from.id]: !0,
      [i.to.CONCEPT_ID]: !0
    };
    !Me(c, r) && a(c);
  }, C = (i) => {
    const c = i.reduce((u, o) => (u[o.from.id] = !0, u[o.to.CONCEPT_ID] = !0, u), {});
    !Me(c, r) && a(c);
  }, h = (i) => (c) => ({
    onMouseOver: () => d(i),
    // onMouseLeave: onHoverOut,
    className: "td",
    styles: {
      color: r != null && r[i.from.id] && (r != null && r[i.to.CONCEPT_ID]) ? An(
        0.05,
        rt.get(me.STANDARD).color
      ) : void 0,
      ...c
    }
  }), l = (i, c, u) => (o, E = !1) => ({
    onMouseOver: () => C(i),
    // onMouseLeave: onHoverOut,
    className: "td",
    rowSpan: u,
    styles: {
      color: r != null && r[c.from.id] && !E ? rt.get(me.NON_STANDARD).color : void 0,
      ...o
    }
  });
  return /* @__PURE__ */ e.jsx(F, { onMouseLeave: () => a(null), children: /* @__PURE__ */ e.jsx(
    Ue,
    {
      data: n,
      getRowId: (i) => i._id,
      withDuplicates: !0,
      hideSettings: !0,
      customTableRow: ({ data: i, row: c, ...u }) => {
        const o = i.length + 1, E = i.every(
          (p) => t[p._id]
        ), T = i.some(
          (p) => t[p._id]
        ), x = c.getVisibleCells().map((p) => ({
          width: p.column.getCanResize() ? "auto" : p.column.getSize(),
          maxWidth: p.column.getSize(),
          minWidth: p.column.getSize(),
          overflowX: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }));
        return /* @__PURE__ */ e.jsx(
          F,
          {
            component: "tbody",
            className: "tbody",
            sx: {
              "&.tbody:hover .tr": {
                backgroundColor: "#2183d91a"
              }
            },
            children: i.map((p, O) => {
              const N = h(p), A = l(
                i,
                p,
                o
              );
              return (
                // <ConceptPreviewTooltip
                //   from={row.from}
                //   to={row.to}
                //   key={row._id}
                // >
                /* @__PURE__ */ Jt(F, { ...u, component: "tr", key: p._id }, O === 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx(
                    ne,
                    {
                      className: "td",
                      rowSpan: o,
                      styles: { ...x[0], textOverflow: "unset" },
                      children: /* @__PURE__ */ e.jsx(
                        re,
                        {
                          size: "small",
                          sx: { mt: -0.5 },
                          checked: E,
                          indeterminate: T && !E,
                          onChange: (j, b) => {
                            s((P) => ({
                              ...P,
                              ...i.reduce((f, I) => (f[I._id] = b, f), {})
                            }));
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ e.jsx(ne, { ...A(x[1]), row: p.from, children: p.from.CONCEPT_ID }),
                  /* @__PURE__ */ e.jsx(ne, { ...A(x[2]), row: p.from, children: p.from.CONCEPT_CODE }),
                  /* @__PURE__ */ e.jsx(ne, { ...A(x[3]), row: p.from, children: p.from.CONCEPT_NAME }),
                  /* @__PURE__ */ e.jsx(
                    ne,
                    {
                      rowSpan: o,
                      className: "td",
                      ...A(
                        { ...x[4], pointerEvents: "none" },
                        !0
                      ),
                      children: "→"
                    }
                  )
                ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {}), /* @__PURE__ */ e.jsx(
                  ne,
                  {
                    className: "td",
                    style: {
                      ...x[5],
                      textOverflow: "unset"
                    },
                    children: /* @__PURE__ */ e.jsx(
                      re,
                      {
                        size: "small",
                        sx: { mt: -0.5 },
                        checked: t[p._id] || !1,
                        onChange: (j, b) => {
                          s((P) => ({
                            ...P,
                            [p._id]: b
                          }));
                        }
                      }
                    )
                  }
                ), /* @__PURE__ */ e.jsx(ne, { ...N(x[6]), row: p.to, children: p.to.CONCEPT_ID }), /* @__PURE__ */ e.jsx(ne, { ...N(x[7]), row: p.to, children: p.to.CONCEPT_CODE }), /* @__PURE__ */ e.jsx(ne, { ...N(x[8]), row: p.to, children: p.to.CONCEPT_NAME }))
              );
            })
          }
        );
      },
      columns: js
    }
  ) });
}, Ps = [
  {
    header: "Non-Standard",
    enableHiding: !1,
    enableSorting: !1,
    id: "non-standard",
    columns: [
      ct("actions"),
      lt("conceptId___standard"),
      it("conceptCode___standard"),
      dt("conceptName___standard")
    ]
  },
  {
    header: "",
    enableHiding: !1,
    id: "actions_header",
    enableResizing: !1,
    enableSorting: !1,
    columns: [En]
  },
  {
    header: "Standard",
    id: "standard",
    enableHiding: !1,
    enableSorting: !1,
    columns: [
      ct(),
      lt("conceptId___non-standard"),
      it("conceptCode___non-standard"),
      dt("conceptName___non-standard")
    ]
  }
], vs = ({
  selectedRows: t,
  data: n,
  setSelectedRows: s,
  setActiveRow: a,
  activeRow: r
}) => {
  const d = (i) => {
    const c = i.reduce((u, o) => (u[o.from.id] = !0, u[o.to.CONCEPT_ID] = !0, u), {});
    !Me(c, r) && a(c);
  }, C = (i, c) => {
    const u = { [c.from.id]: !0, [c.to.CONCEPT_ID]: !0 };
    !Me(u, r) && a({ [c.from.id]: !0, [c.to.CONCEPT_ID]: !0 });
  }, h = (i, c, u) => (o, E = !1) => ({
    onMouseOver: () => d(i),
    // onMouseLeave: onHoverOut,
    className: "td",
    rowSpan: u,
    sx: {
      color: r != null && r[c.to.CONCEPT_ID] && !E ? rt.get(me.STANDARD).color : void 0,
      ...o
    }
  }), l = (i) => (c) => ({
    onMouseOver: (u) => C(u, i),
    // onMouseLeave: onHoverOut,
    className: "td",
    sx: {
      color: r != null && r[i.from.id] && (r != null && r[i.to.CONCEPT_ID]) ? rt.get(me.NON_STANDARD).color : void 0,
      ...c
    }
  });
  return /* @__PURE__ */ e.jsx(F, { onMouseLeave: () => a(null), children: /* @__PURE__ */ e.jsx(
    Ue,
    {
      data: n,
      columns: Ps,
      getRowId: (i) => i._id,
      withDuplicates: !0,
      hideSettings: !0,
      customTableRow: ({ data: i, row: c, ...u }) => {
        const o = i.length + 1, E = i.every(
          (p) => t[p._id]
        ), T = i.some(
          (p) => t[p._id]
        ), x = c.getVisibleCells().map((p) => ({
          width: p.column.getCanResize() ? "auto" : p.column.getSize(),
          maxWidth: p.column.getSize(),
          minWidth: p.column.getSize(),
          overflowX: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }));
        return /* @__PURE__ */ e.jsx(
          F,
          {
            component: "tbody",
            className: "tbody",
            sx: {
              "&.tbody:hover .tr": {
                backgroundColor: "#2183d91a"
              }
            },
            children: i.map((p, O) => {
              const N = h(i, p, o), A = l(p);
              return /* @__PURE__ */ Jt(F, { ...u, component: "tr", key: p._id }, /* @__PURE__ */ e.jsx(
                ne,
                {
                  className: "td",
                  style: { ...x[0], textOverflow: "unset" },
                  children: /* @__PURE__ */ e.jsx(
                    re,
                    {
                      size: "small",
                      sx: { mt: -0.5 },
                      checked: t[p._id] || !1,
                      onChange: (j, b) => {
                        s((P) => ({
                          ...P,
                          [p._id]: b
                        }));
                      }
                    }
                  )
                }
              ), /* @__PURE__ */ e.jsx(ne, { ...A(x[1]), row: p.from, children: p.from.CONCEPT_ID }), /* @__PURE__ */ e.jsx(ne, { ...A(x[2]), row: p.from, children: p.from.CONCEPT_CODE }), /* @__PURE__ */ e.jsx(ne, { ...A(x[3]), row: p.from, children: p.from.CONCEPT_NAME }), O === 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(
                  ne,
                  {
                    ...N(
                      { ...x[4], pointerEvents: "none" },
                      !0
                    ),
                    children: "→"
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  ne,
                  {
                    className: "td",
                    rowSpan: o,
                    style: { ...x[5], textOverflow: "unset" },
                    children: /* @__PURE__ */ e.jsx(
                      re,
                      {
                        size: "small",
                        sx: { mt: -0.5 },
                        checked: E,
                        indeterminate: T && !E,
                        onChange: (j, b) => {
                          s((P) => ({
                            ...P,
                            ...i.reduce((f, I) => (f[I._id] = b, f), {})
                          }));
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(ne, { ...N(x[6]), row: p.to, children: p.to.CONCEPT_ID }),
                /* @__PURE__ */ e.jsx(ne, { ...N(x[7]), row: p.to, children: p.to.CONCEPT_CODE }),
                /* @__PURE__ */ e.jsx(ne, { ...N(x[8]), row: p.to, children: p.to.CONCEPT_NAME })
              ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {}));
            })
          }
        );
      }
    }
  ) });
};
function ws(t, n) {
  const s = Mn("RecordCountsDataSource"), [a, r] = U([]), [d, C] = U(null), [h, l] = U(m.INITIAL), i = async () => {
    l(m.IN_PROGRESS);
    try {
      const u = await Es(), o = await (t ? Ss(t) : Promise.resolve(null));
      r(u), C(o), l(m.SUCCESS);
    } catch (u) {
      console.error(u), l(m.ERROR);
    }
  }, c = (u) => {
    u ? Gn("RecordCountsDataSource", u) : zn("RecordCountsDataSource"), n();
  };
  return W(() => {
    i();
  }, [t]), { dataSource: d, dataSources: a, status: h, dataSourceId: s, setDataSourceId: c };
}
const ks = ({ onCookieChange: t, size: n, variant: s = "inline" }) => {
  const a = vt(
    (o) => o.user.data.activeTenant
  ), { dataSource: r, dataSources: d, status: C, dataSourceId: h, setDataSourceId: l } = ws(a, t), i = (d == null ? void 0 : d.find((o) => String(o.id) === String(h))) || r, c = i && !(d != null && d.some((o) => String(o.id) === String(i.id))) ? [i, ...d || []] : d || [], u = c.length ? c.map((o) => ({
    id: String(o.id),
    name: o.name
  })) : [
    {
      id: "",
      name: "No data sources available",
      disabled: !0
    }
  ];
  return s === "compact" ? C === m.IN_PROGRESS ? /* @__PURE__ */ e.jsx(
    Lt,
    {
      width: 30,
      height: 30,
      animation: "wave",
      sx: {
        bgcolor: "secondary.main",
        opacity: 0.4
      }
    }
  ) : C !== m.SUCCESS ? null : /* @__PURE__ */ e.jsx(be, { text: "View record counts for data source", arrow: !0, placement: "top", children: /* @__PURE__ */ e.jsx(F, { sx: { display: "inline-block" }, children: /* @__PURE__ */ e.jsx(
    Pn,
    {
      title: /* @__PURE__ */ e.jsx(te, { iconName: "database", sx: { fontSize: 16 } }),
      name: "rc-data-source",
      variant: "text",
      color: "primary",
      closeOnSelect: !0,
      placement: "bottom-start",
      preventOverflow: !0,
      disablePortal: !1,
      options: u,
      sx: (o) => ({
        minWidth: 0,
        px: 1,
        bgcolor: Ft(0.05, o.palette.backgroundColor.light),
        "&:hover": {
          bgcolor: Ft(0.1, o.palette.backgroundColor.dark)
        }
      }),
      onClick: (o) => {
        o != null && o.disabled || l(o.id);
      }
    }
  ) }) }) : /* @__PURE__ */ e.jsxs(
    F,
    {
      width: 300,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      children: [
        C === m.IN_PROGRESS && /* @__PURE__ */ e.jsx(
          Lt,
          {
            width: "100%",
            height: n === "md" ? 30 : 24,
            animation: "wave",
            sx: {
              bgcolor: "secondary.main",
              opacity: 0.4
            }
          }
        ),
        C === m.SUCCESS && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(se, { variant: "subtitle2", children: "View record count for:" }),
          /* @__PURE__ */ e.jsx(
            F,
            {
              flexGrow: 1,
              ml: 1,
              sx: n === "md" ? {
                "&, .autocomplete-input-container": {
                  height: 30
                }
              } : void 0,
              children: /* @__PURE__ */ e.jsx(
                Fe,
                {
                  size: "small",
                  fullWidth: !0,
                  value: i,
                  options: d,
                  name: "rc-data-source",
                  placeholder: "Select Data Source",
                  onChange: function(o, E) {
                    l(E == null ? void 0 : E.id);
                  },
                  isOptionEqualToValue: (o, E) => o.id === E.id,
                  getOptionLabel: function(o) {
                    return (o == null ? void 0 : o.name) || "";
                  },
                  disableClearable: !0
                }
              )
            }
          )
        ] })
      ]
    }
  );
}, Sn = (t, n, s, a, r, d) => {
  const C = [
    {
      header: "Id",
      accessorKey: "conceptId",
      id: "CONCEPT_ID",
      enableColumnFilter: !1,
      size: 100,
      enableHiding: !1
    },
    {
      header: "Code",
      accessorKey: "concept.CONCEPT_CODE",
      id: "CONCEPT_CODE",
      size: 120,
      enableColumnFilter: !1,
      sortingFn: "alphanumeric"
    },
    {
      header: "Name",
      accessorKey: "concept.CONCEPT_NAME",
      id: "CONCEPT_NAME",
      size: 200,
      minSize: 120,
      filterFn: (p, O, N) => {
        var A, j, b;
        return [
          (A = p.original.concept) == null ? void 0 : A.CONCEPT_ID,
          (j = p.original.concept) == null ? void 0 : j.CONCEPT_CODE,
          (b = p.original.concept) == null ? void 0 : b.CONCEPT_NAME
        ].some(
          (P) => String(P).toLowerCase().includes(N[0].toLowerCase())
        );
      },
      sortingFn: "alphanumeric",
      meta: {
        filterVariant: "value"
      }
    },
    {
      header: "Standard Concept",
      accessorFn: (p) => {
        var O;
        return ((O = p.concept) == null ? void 0 : O.STANDARD_CONCEPT) || "N";
      },
      id: "STANDARD_CONCEPT",
      align: "center",
      filterFn: "arrIncludesSomeEqual",
      cell: ({ renderValue: p, row: O }) => {
        if (!O.original.concept) return;
        const { color: N, caption: A } = at(p());
        return /* @__PURE__ */ e.jsx(
          tn,
          {
            text: A,
            color: N,
            align: "center",
            minWidth: 92
          }
        );
      },
      enableResizing: !1,
      meta: {
        filterOrder: 3,
        renderFilter: (p) => at(p).caption
      }
    },
    {
      header: "Class",
      accessorKey: "concept.CONCEPT_CLASS_ID",
      id: "CONCEPT_CLASS_ID",
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterHeader: "Concept Class",
        filterOrder: 2
      },
      size: 120
    }
  ], h = [
    {
      header: "Domain",
      accessorKey: "concept.DOMAIN_ID",
      id: "DOMAIN_ID",
      filterFn: "arrIncludesSomeEqual",
      size: 100,
      meta: {
        filterOrder: 1
      }
    },
    {
      header: "Vocabulary",
      accessorKey: "concept.VOCABULARY_ID",
      id: "VOCABULARY_ID",
      filterFn: "arrIncludesSomeEqual",
      size: 120,
      minSize: 80,
      meta: {
        filterOrder: 0
      }
    }
  ], l = [
    {
      header: "Distance",
      accessorKey: "concept.DISTANCE"
    }
  ], i = [
    {
      header: "RC",
      id: "RECORD_COUNT",
      accessorKey: "concept.RECORD_COUNT",
      size: 80,
      cell: ({ getValue: p }) => p() ? et(p()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Record Counts (RC)",
        filterOrder: 5
      }
    },
    {
      header: "DRC",
      id: "DESCENDANT_RECORD_COUNT",
      accessorKey: "concept.DESCENDANT_RECORD_COUNT",
      size: 80,
      cell: ({ getValue: p }) => p() ? et(p()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Descendant Record Counts (DRC)",
        filterOrder: 6
      }
    },
    {
      header: "PC",
      id: "PERSON_COUNT",
      accessorKey: "concept.PERSON_COUNT",
      size: 80,
      cell: ({ getValue: p }) => p() ? et(p()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Person Counts (PC)",
        filterOrder: 7
      }
    },
    {
      header: "DPC",
      id: "DESCENDANT_PERSON_COUNT",
      accessorKey: "concept.DESCENDANT_PERSON_COUNT",
      size: 80,
      cell: ({ getValue: p }) => p() ? et(p()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Descendant Person Counts (DPC)",
        filterOrder: 8
      }
    }
  ], c = [
    nt(
      "excluded",
      "Exclude",
      `Marks the concept to be explicitly excluded from the concept Set.
It is possible to exclude a whole sub-trees of concepts by combining Exclude and Descendants/Hierarchy options.
Overrides the implicit inclusion of concepts from Descendants option.`,
      r,
      Ls(d)
    ),
    nt(
      "descendants",
      "Descendants",
      `Includes child concepts from the standard hierarchy, utilizing OMOP CDM relation table data.
Option is available only for standard and classification concepts.`,
      r,
      Yt()
    ),
    nt(
      "mapped",
      "Mapped",
      `Includes additional non-standard concepts, that this concept has a 'Maps to' relationship with.
If the concept is not mapped to any other concepts with 'Maps to' relationship, it will be excluded from the final list.
Option is available only for standard and classification concepts.`,
      r,
      Yt()
    ),
    nt(
      "hierarchy",
      "Hierarchy",
      `Includes child concepts from the native hierarchy of source data, utilizing OMOP CDM relation table data.
Work same way as Descendants, but for non-standard concepts.
Option is available only for non-standard concepts.`,
      r,
      Fs()
    )
  ], u = [
    {
      header: "Invalid Reason",
      accessorKey: "concept.INVALID_REASON_CAPTION",
      id: "INVALID_REASON_CAPTION",
      size: 0,
      enableHiding: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        invisible: !0,
        filterOrder: 4
      }
    }
  ], o = s ? [...i] : [], E = n ? [...l] : [], T = a ? [...c] : [], x = t ? [...h] : [];
  return [
    ...C,
    ...E,
    ...o,
    ...x,
    ...T,
    ...u
  ];
}, nt = (t, n, s, a, r, d = 85) => ({
  header: (C) => /* @__PURE__ */ e.jsx(
    wn,
    {
      ...C,
      title: n,
      disableAllActions: a,
      getDisabledCheckboxCondition: r,
      accessor: t,
      description: s,
      iconMode: !0
    }
  ),
  accessorKey: t,
  size: d,
  enableResizing: !1,
  enableHiding: !1,
  enableSorting: !1,
  enableColumnFilter: !1,
  meta: {
    align: "center",
    headerAlign: "center"
  },
  cell: (C) => {
    var l, i;
    const h = (i = (l = C.row).getIsSelected) == null ? void 0 : i.call(l);
    return /* @__PURE__ */ e.jsx(
      vn,
      {
        ...C,
        value: C.renderValue(),
        align: "center",
        disabled: C.disabled || !h && a || r(C.row.original)
      }
    );
  }
}), Ls = (t) => (n) => {
  var s;
  return ((s = n.concept) == null ? void 0 : s.CONCEPT_ID) === t;
}, Yt = () => (t) => {
  var n;
  return ((n = t.concept) == null ? void 0 : n.STANDARD_CONCEPT_CAPTION) === me.NON_STANDARD_CAPTION;
}, Fs = () => (t) => {
  var n, s;
  return ((n = t.concept) == null ? void 0 : n.STANDARD_CONCEPT_CAPTION) === me.STANDARD_CAPTION || ((s = t.concept) == null ? void 0 : s.STANDARD_CONCEPT_CAPTION) === me.CLASSIFICATION_CAPTION;
}, Us = Q(Ee)`
  ${({ hasHeaderInfo: t }) => t ? `
    .collapsible-content-block__title {
      align-items: center;
      line-height: normal;
      min-height: 46px;
      padding-top: 6px;
      padding-bottom: 6px;
    }

    .collapsible-content-block__title > div {
      min-width: 0;
      width: 100%;
      flex-wrap: wrap;
      row-gap: 8px;
    }

    .collapsible-content-block__title-text {
      flex: 1 1 360px;
      min-width: 0;
      padding-right: 16px;
      font-weight: 400;
      overflow: hidden;

      > span {
        display: block;
        min-width: 0;
      }
    }

    .collapsible-content-block__actions {
      flex: 0 1 auto;
      min-width: 0;
      align-self: center;

      > div {
        flex-wrap: wrap;
        justify-content: flex-end;
        row-gap: 8px;
      }
    }
  ` : ""}
`, mn = Q.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 980px;
  min-width: 0;
  color: ${({ theme: t }) => {
  var n;
  return ((n = t.palette.textColor) == null ? void 0 : n.main) || "#1d2d4d";
}};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  svg {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
  }

  span {
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`, _t = {
  xs: "250px",
  lg: "280px",
  xl: "300px"
};
function ue(t) {
  var y, z;
  const {
    hasDomainAndVocabulary: n = !0,
    hasDistance: s = !1,
    hasRcDrc: a = !0,
    hasRcDrcSelect: r = !1,
    hasHierarchy: d = !0,
    disableEdit: C = !0,
    currentConceptSetId: h,
    hasDraftConceptModal: l = !1,
    title: i = "All Concepts",
    headerInfo: c,
    status: u,
    noDataText: o = "No data currently available",
    collapsible: E = !1,
    outlined: T = !1,
    noGaps: x = !1,
    storageKey: p,
    hasFilters: O,
    wrapColumns: N = (k) => k
  } = t, A = vt(
    (k) => k.user.data
  ), j = t.storage ?? cn(
    `${A.activeTenant}${p || "concepts-table"}`,
    t.hiddenColumns ?? {
      shortcut: !0,
      "created.timestamp": !0
    }
  ), b = K(() => {
    var $;
    return (($ = t.data) == null ? void 0 : $.map(
      (Y) => {
        var oe;
        return ((oe = t.selectedConcepts) == null ? void 0 : oe[Y.id]) || Y;
      }
    )) || [];
  }, [t.data, t.selectedConcepts]), P = t.selectedConcepts ? Object.keys(t.selectedConcepts).reduce((k, $) => (k[$] = !0, k), {}) : {}, f = K(
    () => N(
      Sn(
        n,
        s,
        a,
        d,
        C,
        h
      )
    ),
    [
      n,
      s,
      a,
      d,
      C,
      h
    ]
  ), I = t.onSelectAll ? async (k, $) => {
    t.variant === "controlled" && t.onSelectAll && ($ ? await t.fetchData(0, t.totalElements, null, !0).then(t.onSelectAll) : t.onSelectAll({}));
  } : void 0, R = t.variant == "uncontrolled" ? t.reloadData : t.fetchData;
  return /* @__PURE__ */ e.jsx(
    Us,
    {
      collapsible: E,
      outlined: T,
      noGaps: x,
      defaultState: !E,
      hasHeaderInfo: !!c,
      actions: /* @__PURE__ */ e.jsx(
        F,
        {
          display: "flex",
          minHeight: 42,
          alignItems: "center",
          sx: {
            "> *:not(:first-of-type)": {
              ml: 1
            }
          },
          children: t.customActions
        }
      ),
      title: c || /* @__PURE__ */ e.jsx(
        Le,
        {
          title: i,
          count: t.variant !== "uncontrolled" ? t.totalElements : b.length,
          loading: u === m.IN_PROGRESS || u === m.IN_PROGRESS_RELOAD
        }
      ),
      children: /* @__PURE__ */ e.jsx(_, { container: !0, spacing: 4, flexWrap: "nowrap", children: /* @__PURE__ */ e.jsx(
        _,
        {
          item: !0,
          flexGrow: 1,
          sx: {
            width: {
              xs: `calc(100% - ${_t.xs})`,
              lg: `calc(100% - ${_t.lg})`,
              xl: `calc(100% - ${_t.xl})`
            },
            ...l ? { mb: 5 } : { borderRadius: 1 }
          },
          children: /* @__PURE__ */ e.jsx(
            Ue,
            {
              variant: t.variant || "controlled",
              data: b,
              columns: f,
              pageSize: Number(t.pageSize) || null,
              pageIndex: Number(t.pageIndex) || null,
              defaultSorting: (y = j.storage) == null ? void 0 : y.sort,
              onRowSelect: t.onRowSelect,
              getRowId: t.getRowId || ((k) => String(k.id)),
              loadingMessage: "Loading concepts table...",
              enableRowSelection: t.enableRowSelection,
              onEdit: t.onEdit,
              onSelectAll: I,
              setPagination: t.setPagination,
              selectedRowIds: P,
              onRowClick: t.onRowClick,
              loading: u === m.IN_PROGRESS || u === m.IN_PROGRESS_RELOAD,
              isInitial: u === m.INITIAL,
              noDataText: o,
              columnVisibility: (z = j.storage) == null ? void 0 : z.columns,
              persistSettings: j.setStorage,
              showFilterToggle: t.showFilterToggle,
              tableOptionsActions: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                r && !!R && /* @__PURE__ */ e.jsx(
                  ks,
                  {
                    onCookieChange: R,
                    variant: "compact"
                  }
                ),
                t.tableOptionsActions
              ] }),
              children: t.children,
              ...t.variant !== "uncontrolled" && {
                totalElements: t.totalElements,
                pageCount: Number(t.pageCount),
                fetchData: t.fetchData,
                hasFilters: O,
                searchComponent: t.searchComponent
              },
              ...t.variant !== "controlled" && {
                enableFiltering: t.enableFiltering
              },
              selectedElements: t.selectedConcepts,
              disabled: t.disabled,
              filtersDefaultClosed: t.filtersDefaultClosed
            }
          )
        }
      ) })
    }
  );
}
const Ms = (t, n) => {
  const s = {};
  return t.map((a) => ({ ...a.to, from: a.from })).forEach((a) => {
    let r = ve(a);
    s[r.conceptId] ? s[r.conceptId].from.push(a.from) : (r.action = n[a.CONCEPT_ID] ? "add" : "default", r.id = yt(), r.from = [a.from], s[r.conceptId] = r);
  }), s;
}, zs = (t, n, s) => (a) => [
  {
    header: "",
    accessorKey: "conceptId",
    id: "actions",
    size: t ? 134 : 40,
    enableResizing: !1,
    meta: {
      columnType: "action"
    },
    cell: ({ getValue: r, row: d }) => /* @__PURE__ */ e.jsx(F, { display: "flex", alignItems: "center", mx: -0.5, children: n[r()] ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        be,
        {
          text: "This concept is already present in concept set. Please choose action",
          children: /* @__PURE__ */ e.jsx(
            F,
            {
              sx: {
                bgcolor: "#ffac3342",
                borderRadius: "4px",
                width: 24,
                height: 24,
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                p: "2px",
                boxSizing: "border-box",
                mr: 1
              },
              children: /* @__PURE__ */ e.jsx(
                te,
                {
                  iconName: "warning",
                  color: "warning",
                  sx: {
                    top: -1,
                    position: "relative",
                    fontSize: 20
                  }
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx(F, { minWidth: "86px", children: /* @__PURE__ */ e.jsx(
        nn,
        {
          size: "small",
          options: [
            { value: "replace", name: "Replace" },
            { value: "add", name: "Add" }
          ],
          value: d.original.action,
          onChange: (C) => {
            s((h) => ({
              ...h,
              [d.original.conceptId]: {
                ...d.original,
                action: C
              }
            }));
          },
          fullWidth: !0
        }
      ) })
    ] }) : /* @__PURE__ */ e.jsx(
      F,
      {
        sx: {
          bgcolor: "#aed88342",
          borderRadius: "4px",
          width: 24,
          height: 24,
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          p: "2px",
          boxSizing: "border-box",
          mr: 1
        },
        children: /* @__PURE__ */ e.jsx(
          te,
          {
            iconName: "check",
            color: "success",
            sx: { left: -2, position: "relative" }
          }
        )
      }
    ) })
  },
  ...a.filter((r) => r.header !== "Class")
], Gs = ({
  selectedConcepts: t,
  onClose: n,
  items: s,
  onUpdate: a
}) => {
  const r = Be(Object.values(s), "conceptId"), [d, C] = U(
    Ms(t, r)
  ), h = () => {
    const i = {}, c = {};
    Object.values(d).forEach((u) => {
      switch (u.action) {
        case "add":
          i[u.id] = u, u.from.forEach((o) => {
            c[o.id] = o;
          }), delete i[u.id].action, delete i[u.id].from;
          break;
        case "replace":
          i[u.id] = u, u.from.forEach((o) => {
            c[o.id] = o;
          }), r[u.conceptId] && r[u.conceptId].forEach((o) => {
            c[o.id] = !0;
          }), delete i[u.id].action, delete i[u.id].from;
          break;
        case "default":
          i[u.id] = u, u.from.forEach((o) => {
            c[o.id] = o;
          }), delete i[u.id].action, delete i[u.id].from;
          break;
      }
    }), a({ updated: i, deleted: c });
  }, l = Object.values(d).some(
    (i) => r[i.conceptId]
  );
  return /* @__PURE__ */ e.jsxs(
    _,
    {
      container: !0,
      flexDirection: "column",
      position: "relative",
      pb: "60px",
      display: "flex",
      width: "inherit",
      children: [
        /* @__PURE__ */ e.jsx(
          _,
          {
            item: !0,
            xs: 12,
            bgcolor: "white",
            sx: (i) => ({ boxShadow: i.customShadows[3] }),
            p: 2,
            children: /* @__PURE__ */ e.jsx(se, { variant: "h1", children: "Concept set preview" })
          }
        ),
        /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsxs(Qe, { outlined: !0, elevated: !0, children: [
          Object.values(d).some(
            (i) => {
              var c;
              return ((c = r[i.conceptId]) == null ? void 0 : c.length) > 0;
            }
          ) && /* @__PURE__ */ e.jsx(F, { p: 2, children: /* @__PURE__ */ e.jsxs(ut, { severity: "warning", children: [
            "Some of the mapped ",
            /* @__PURE__ */ e.jsx("b", { children: "standard concepts are already present" }),
            " ",
            "in the concept set. There may be multiple occurrences. You can choose to either ",
            /* @__PURE__ */ e.jsx("b", { children: "Add" }),
            " a new concept record to the concept set and address the conflicts later, or ",
            /* @__PURE__ */ e.jsx("b", { children: "Replace" }),
            " all existing occurrences now."
          ] }) }),
          /* @__PURE__ */ e.jsx(
            ue,
            {
              disableEdit: !1,
              wrapColumns: zs(
                l,
                r,
                C
              ),
              data: Object.values(d),
              variant: "uncontrolled",
              status: m.SUCCESS,
              onEdit: (i) => {
                C((c) => ({
                  ...c,
                  ...(Array.isArray(i) ? i : [i]).reduce((u, o) => (u[o.row.conceptId] = {
                    ...o.row,
                    [o.columnId]: o.value
                  }, u), {})
                }));
              }
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsxs(_, { item: !0, position: "fixed", bottom: 0, right: 0, width: "inherit", children: [
          /* @__PURE__ */ e.jsx(qe, {}),
          /* @__PURE__ */ e.jsxs(
            F,
            {
              bgcolor: "white",
              px: 2,
              py: 1,
              justifyContent: "flex-end",
              display: "flex",
              sx: {
                "*:not(:last-of-type)": {
                  mr: 1
                }
              },
              children: [
                /* @__PURE__ */ e.jsx(
                  _e,
                  {
                    onClick: n,
                    color: "info",
                    title: "Cancel",
                    iconName: "close",
                    noCollapse: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  pt,
                  {
                    onClick: h,
                    color: "success",
                    title: "Apply",
                    iconName: "submit",
                    noCollapse: !0
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}, Hs = (t) => {
  var N, A;
  const { items: n, onUpdate: s } = t, [a, r] = U({}), [d, C] = U(null), [h, l] = U(!1), i = B(async () => {
    const b = an(n).filter((f) => {
      if (f.STANDARD_CONCEPT !== "S" && f.STANDARD_CONCEPT !== "C")
        return !0;
    }), P = b.map(
      (f) => f.CONCEPT_ID
    );
    return Os(P).then((f) => {
      const I = [];
      for (let R of f)
        for (let y of R.MAPPED_FROM) {
          const z = b.find(
            (k) => k.CONCEPT_ID === y
          );
          I.push({
            from: z,
            to: R,
            _id: R.CONCEPT_ID + "_" + z.id
          });
        }
      return I;
    });
  }, [n]), { state: c, status: u } = Nt(i), o = B((j, b) => {
    let P = [];
    const f = {};
    if (b != null && b.length && (b.forEach((I) => {
      const R = I.from.id;
      f[R] = f[R] ? f[R] + 1 : 1;
    }), b))
      switch (j) {
        case "all":
          P = b;
          break;
        case "one-to-one":
          P = b.filter(
            (I) => {
              var R, y;
              return ((y = (R = I.to) == null ? void 0 : R.MAPPED_FROM) == null ? void 0 : y.length) === 1 && f[I.from.id] === 1;
            }
          );
          break;
        case "n-to-one":
          P = b.filter(
            (I) => {
              var R, y;
              return ((y = (R = I.to) == null ? void 0 : R.MAPPED_FROM) == null ? void 0 : y.length) > 1;
            }
          );
          break;
        case "one-to-n":
          P = b.filter(
            (I) => f[I.from.id] > 1
          );
          break;
      }
    return P;
  }, []), E = K(
    () => Object.values(Be(o("all", c), "from.id")),
    [c]
  ), T = K(
    () => Ne(o("one-to-one", c), "_id"),
    [c]
  ), x = K(
    () => Object.values(Be(o("one-to-one", c), "_id")),
    [c]
  ), p = K(
    () => Object.values(Be(o("one-to-n", c), "from.id")),
    [c]
  ), O = K(
    () => Object.values(
      Be(o("n-to-one", c), "to.CONCEPT_ID")
    ),
    [c]
  );
  return u === m.IN_PROGRESS ? /* @__PURE__ */ e.jsx(F, { textAlign: "center", pt: "20%", children: /* @__PURE__ */ e.jsx(Ct, { size: 60, color: "secondary" }) }) : (E == null ? void 0 : E.length) === 0 ? /* @__PURE__ */ e.jsx(_, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(Ee, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(ut, { severity: "info", children: "No suggestions found." }) }) }) : /* @__PURE__ */ e.jsxs(
    _,
    {
      container: !0,
      position: "relative",
      minHeight: "calc(100% - 64px)",
      pb: "60px",
      flexDirection: "column",
      display: "flex",
      width: "inherit",
      children: [
        /* @__PURE__ */ e.jsx(_, { item: !0, p: 2, flexGrow: 1, width: "100%", children: /* @__PURE__ */ e.jsxs(_, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ee,
            {
              title: /* @__PURE__ */ e.jsx(Le, { title: "All", count: (E == null ? void 0 : E.length) || 0 }),
              actions: /* @__PURE__ */ e.jsx(
                _e,
                {
                  onClick: (j) => {
                    j.stopPropagation(), r(T);
                  },
                  color: "info",
                  title: "Select all one to one mappings",
                  iconName: "submit",
                  noCollapse: !0,
                  disabled: (E == null ? void 0 : E.length) === 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              collapsible: !!(E != null && E.length),
              defaultState: (E == null ? void 0 : E.length) > 0,
              children: /* @__PURE__ */ e.jsx(
                xt,
                {
                  selectedRows: a,
                  setSelectedRows: r,
                  data: E,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ee,
            {
              title: /* @__PURE__ */ e.jsx(
                Le,
                {
                  title: "One-To-One",
                  count: (x == null ? void 0 : x.length) || 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              collapsible: !!(x != null && x.length),
              defaultState: !1,
              children: /* @__PURE__ */ e.jsx(
                xt,
                {
                  selectedRows: a,
                  setSelectedRows: r,
                  data: x,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ee,
            {
              title: /* @__PURE__ */ e.jsx(
                Le,
                {
                  title: "One-To-Many",
                  count: (p == null ? void 0 : p.length) || 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              collapsible: !!(p != null && p.length),
              defaultState: !1,
              children: /* @__PURE__ */ e.jsx(
                xt,
                {
                  selectedRows: a,
                  setSelectedRows: r,
                  data: p,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Ee,
            {
              title: /* @__PURE__ */ e.jsx(
                Le,
                {
                  title: "Many-To-One",
                  count: ((N = O.flat()) == null ? void 0 : N.length) || 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              defaultState: !1,
              collapsible: !!(O != null && O.length),
              children: /* @__PURE__ */ e.jsx(
                vs,
                {
                  selectedRows: a,
                  setSelectedRows: r,
                  data: O,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) })
        ] }) }),
        /* @__PURE__ */ e.jsxs(_, { item: !0, position: "fixed", bottom: 0, right: 0, width: "inherit", children: [
          /* @__PURE__ */ e.jsx(qe, {}),
          /* @__PURE__ */ e.jsx(F, { bgcolor: "white", px: 2, py: 1, textAlign: "right", children: /* @__PURE__ */ e.jsx(
            pt,
            {
              onClick: () => l(!0),
              color: "success",
              title: "Apply changes",
              iconName: "submit",
              noCollapse: !0,
              disabled: ((A = Object.keys(a)) == null ? void 0 : A.length) === 0
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx(
          We,
          {
            open: h,
            onClose: function() {
              l(!1);
            },
            children: /* @__PURE__ */ e.jsx(
              Gs,
              {
                items: n,
                selectedConcepts: (c == null ? void 0 : c.filter((j) => a[j._id])) || [],
                onUpdate: s,
                onClose: function() {
                  l(!1);
                }
              }
            )
          }
        )
      ]
    }
  );
}, $s = {
  status: m.INITIAL,
  typeContainer: ye.WORKSPACE,
  conceptSet: null,
  parentId: null,
  error: null
}, Bs = (t, n) => Pe(
  t,
  (s) => {
    switch (n.type) {
      case "CREATE_CONCEPT_SET":
        s.status = m.IN_PROGRESS;
        break;
      case "CREATE_CONCEPT_SET_DONE":
        s.conceptSet = n.payload, s.status = m.SUCCESS;
        break;
    }
  }
), Vs = (t, n) => {
  switch (t) {
    case ye.WORKSPACE:
      return (s) => bs(s);
    case ye.STUDY:
      return (s) => Ns(n, s);
  }
}, Qs = (t) => {
  const { enqueueSnackbar: n } = ht(), [s, a] = Ae(Bs, $s), r = B(
    async ({ name: d, parentId: C, typeContainer: h }) => {
      a({
        type: "CREATE_CONCEPT_SET"
        /* CREATE_CONCEPT_SET */
      });
      try {
        const i = await Vs(h, C)({
          name: d,
          items: t
        });
        a({
          type: "CREATE_CONCEPT_SET_DONE",
          payload: i
        }), n({
          message: `Concept Set "${i.name}" was successfully created`
        });
      } catch {
        n({
          message: "Something went wrong",
          variant: "error"
        });
      }
    },
    [s]
  );
  return {
    ...s,
    createNewConceptSet: r
  };
}, Ws = ({
  onClose: t,
  onCancel: n,
  subModules: s,
  concepts: a
}) => {
  var T;
  const [r, d] = U(""), [C, h] = U(
    ye.WORKSPACE
  ), [l, i] = U(""), { status: c, createNewConceptSet: u } = Qs(
    Hn(a)
  ), o = ((T = r.trim()) == null ? void 0 : T.length) === 0 || C === ye.STUDY && !l, E = (x) => {
    u({
      name: r,
      parentId: l,
      typeContainer: C
    }), t();
  };
  return /* @__PURE__ */ e.jsxs(_, { container: !0, justifyContent: "flex-end", spacing: 1, children: [
    /* @__PURE__ */ e.jsxs(_, { item: !0, display: "flex", width: 180, pr: 2, children: [
      /* @__PURE__ */ e.jsxs(
        se,
        {
          variant: "subtitle1",
          component: "label",
          sx: {
            mr: 1,
            whiteSpace: "nowrap",
            sup: {
              color: "error.main",
              ml: 0.25
            }
          },
          children: [
            "Add to",
            /* @__PURE__ */ e.jsx("sup", { children: "*" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(
        nn,
        {
          className: "",
          name: "typeContainer",
          disablePortal: !0,
          id: "typeContainer",
          options: Wn.filter((x) => x.value !== "ATLAS"),
          value: C,
          placeholder: "Select type",
          onChange: (x) => {
            h(x);
          },
          fullWidth: !0
        }
      )
    ] }),
    C === ye.STUDY && /* @__PURE__ */ e.jsxs(_, { item: !0, display: "flex", maxWidth: 300, width: "50%", pr: 2, children: [
      /* @__PURE__ */ e.jsxs(
        se,
        {
          variant: "subtitle1",
          component: "label",
          sx: {
            mr: 1,
            sup: {
              color: "error.main",
              ml: 0.25
            }
          },
          children: [
            "Study",
            /* @__PURE__ */ e.jsx("sup", { children: "*" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        s.study,
        {
          type: "component",
          name: "user-studies-list",
          subModules: s,
          config: {
            onChange: (x) => {
              i((x == null ? void 0 : x.id) || "");
            },
            studyInitialId: null
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsxs(_, { item: !0, flexGrow: 1, children: [
      /* @__PURE__ */ e.jsxs(
        se,
        {
          variant: "subtitle1",
          component: "label",
          sx: {
            mr: 1,
            sup: {
              color: "error.main",
              ml: 0.25
            }
          },
          children: [
            "Name",
            /* @__PURE__ */ e.jsx("sup", { children: "*" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ot,
        {
          value: r,
          onChange: (x) => d(x.target.value),
          placeholder: "Enter concept set name...",
          sx: { minWidth: 200, width: "30%" }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(_, { item: !0, children: /* @__PURE__ */ e.jsx(
      pt,
      {
        onClick: E,
        color: "success",
        iconName: "submit",
        title: "Create",
        disabled: o || c === m.IN_PROGRESS,
        tooltipText: o ? "Fill out missing information" : "",
        loading: c === m.IN_PROGRESS
      }
    ) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, children: /* @__PURE__ */ e.jsx(
      _e,
      {
        onClick: function(x) {
          d(""), i(""), h(ye.WORKSPACE), n();
        },
        iconName: "close",
        title: "Cancel",
        color: "error"
      }
    ) })
  ] });
}, Ys = (t) => {
  const { onOverwriteConceptSet: n, items: s } = t, [a] = U(an(s)), { enqueueSnackbar: r } = ht(), d = B(() => Rs(a).then((p) => (c(
    Ne(
      Mt(p.optimizedConceptSet),
      "id"
    )
  ), p)), [a]), { state: C, status: h } = Nt(d), {
    selectedConcepts: l,
    updateSelectedConceptBulk: i,
    init: c
  } = xe({}, "id"), [u, o] = U(!1), E = () => {
    o((p) => !p);
  }, T = (p) => {
    i(Array.isArray(p) ? p : [p]);
  }, x = () => {
    try {
      n(l), r({
        message: "Overwriting completed successfully",
        variant: "success"
      }), t.onClose();
    } catch (p) {
      console.error("OWERWRITING FAILED", p), r({
        message: "Something went wrong",
        variant: "error"
      });
    }
  };
  if (h === m.IN_PROGRESS)
    return /* @__PURE__ */ e.jsx(Dt, { children: /* @__PURE__ */ e.jsx(Ct, { size: 32 }) });
  if ((C == null ? void 0 : C.optimizedConceptSet.length) === a.length)
    return /* @__PURE__ */ e.jsx(_, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(Ee, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(ut, { severity: "info", children: "Current concept set definition is fully optimized." }) }) });
  if (C && C.optimizedConceptSet.length !== a.length)
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(Ee, { children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, justifyContent: "flex-end", display: "flex", children: u ? /* @__PURE__ */ e.jsx(
        Ws,
        {
          onClose: t.onClose,
          onCancel: E,
          subModules: t.subModules,
          concepts: Object.values(l)
        }
      ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          ae,
          {
            onClick: E,
            name: "createNewConceptSet",
            variant: "outlined",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
            children: "Create new concept set"
          }
        ),
        /* @__PURE__ */ e.jsx(
          ae,
          {
            onClick: x,
            name: "overwriteConceptSet",
            variant: "contained",
            color: "success",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "submit" }),
            sx: { ml: 1 },
            children: "Overwrite current concept set"
          }
        )
      ] }) }) }),
      /* @__PURE__ */ e.jsxs(_, { container: !0, spacing: 2, p: 2, children: [
        /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Qe, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(
          ue,
          {
            variant: "uncontrolled",
            title: "Optimized concepts",
            disableEdit: !0,
            filtersDefaultClosed: !0,
            hasDomainAndVocabulary: !0,
            data: Object.values(l),
            status: h,
            noDataText: "No data currently available",
            selectedConcepts: {},
            onEdit: T,
            hiddenColumns: {
              RECORD_COUNT: !1,
              DESCENDANT_RECORD_COUNT: !1,
              PERSON_COUNT: !1,
              DESCENDANT_PERSON_COUNT: !1,
              CONCEPT_CLASS_ID: !1
            }
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(Qe, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(
          ue,
          {
            variant: "uncontrolled",
            hiddenColumns: {
              RECORD_COUNT: !1,
              DESCENDANT_RECORD_COUNT: !1,
              PERSON_COUNT: !1,
              DESCENDANT_PERSON_COUNT: !1,
              CONCEPT_CLASS_ID: !1
            },
            title: "Removed concepts",
            disableEdit: !0,
            filtersDefaultClosed: !0,
            hasDomainAndVocabulary: !0,
            data: C != null && C.removedConceptSet ? Mt(
              C == null ? void 0 : C.removedConceptSet
            ) : [],
            selectedConcepts: {},
            status: h,
            noDataText: "No data currently available"
          }
        ) }) })
      ] })
    ] });
}, qs = Q(_)(
  ({ theme: t }) => ({
    // backgroundColor: theme.palette.backgroundColor.main,
    // borderRadius: theme.shape.borderRadius + 'px',
    alignItems: "center"
  })
), Ks = Q.div`
  margin-left: 8px;
  background-color: ${({ theme: t }) => {
  var n;
  return ((n = t.palette) == null ? void 0 : n.info.main) + "20";
}};
  color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.textColor.primary;
}};
  border-radius: 2px;
  font-weight: 400;
  padding: 2px 8px;
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  text-decoration: none;
`;
Q(Ee)`
  border: none;
  box-shadow: none;
  margin-bottom: 0;
  > div {
    // padding: 15px 0;
  }
  .collapsible-content-block__title {
    font-size: 14px;
  }
`;
Q.label`
  display: flex;
  align-items: center;
`;
const Xs = Q.section`
  display: flex;
  align-items: center;
  .search-button,
  .reset-button {
    margin-left: 12px;
    min-width: auto;
  }
`;
Q.section``;
const xn = fe((t) => {
  const { onFind: n, initialQuery: s, onClear: a, dense: r, isInitial: d } = t, [C, h] = U(() => s || ""), [l, i] = U(!1), c = (o) => {
    o.preventDefault(), C != null && (h(""), n("", l));
  }, u = ge.useCallback(
    (o) => {
      o.preventDefault(), n(C, l);
    },
    [C, l]
  );
  return ge.useEffect(() => {
    h(s);
  }, [s]), /* @__PURE__ */ e.jsx(_, { container: !0, children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx("form", { onSubmit: u, className: "search-form", action: "", children: /* @__PURE__ */ e.jsxs(Xs, { children: [
    /* @__PURE__ */ e.jsx(
      Ot,
      {
        fullWidth: !0,
        placeholder: "Search...",
        size: "large",
        value: C,
        onChange: (o) => h(o.target.value),
        type: "text",
        name: "search-input",
        InputProps: {
          endAdornment: /* @__PURE__ */ e.jsx(ft, { size: "small", onClick: c, children: /* @__PURE__ */ e.jsx(be, { text: "Clear", children: /* @__PURE__ */ e.jsx(te, { iconName: "close", sx: { fontSize: 14 } }) }) })
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      ae,
      {
        color: "success",
        variant: "contained",
        type: "submit",
        name: "submitSearch",
        size: "large",
        sx: r ? { minWidth: 0 } : {},
        className: "search-button",
        startIcon: r ? void 0 : /* @__PURE__ */ e.jsx(
          te,
          {
            iconName: "search",
            sx: { "&.MuiSvgIcon-root": { fontSize: 18 } }
          }
        ),
        children: r ? /* @__PURE__ */ e.jsx(
          te,
          {
            iconName: "search",
            sx: { "&.MuiSvgIcon-root": { fontSize: 18 } }
          }
        ) : "Search"
      }
    ),
    /* @__PURE__ */ e.jsx(
      ae,
      {
        color: "info",
        variant: "text",
        name: "resetAll",
        size: "small",
        className: "reset-button",
        onClick: (o) => {
          c(o), a == null || a();
        },
        sx: {
          ".start-icon-small svg": { fontSize: 12 },
          whiteSpace: "nowrap",
          ml: 2,
          px: 2,
          fontWeight: 400,
          visibility: d ? "hidden" : "visible"
        },
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "close" }),
        children: "Reset all"
      }
    ),
    /* @__PURE__ */ e.jsxs(
      _,
      {
        item: !0,
        display: "flex",
        pr: 2,
        onClick: (o) => {
          o.stopPropagation();
        },
        children: [
          /* @__PURE__ */ e.jsx(_, { item: !0, px: 1, children: /* @__PURE__ */ e.jsx(
            sn,
            {
              id: "advanced-search-syntax",
              value: l,
              checked: l,
              onChange: (o) => {
                i((E) => !E);
              },
              size: "small",
              color: "info"
            }
          ) }),
          /* @__PURE__ */ e.jsx(
            F,
            {
              component: "label",
              htmlFor: "advanced-search-syntax",
              sx: [
                l ? {} : { opacity: 0.3 },
                { width: 200, color: "primary.main" }
              ],
              children: "Advanced search syntax"
            }
          )
        ]
      }
    )
  ] }) }) }) });
}), Zs = {
  "filter.invalid.reason": ["Valid"],
  "filter.standard.concept": ["Standard"],
  "filter.domain": []
}, Js = ({ title: t = "", description: n = "" }) => /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, mt: 2, container: !0, flexWrap: "nowrap", alignItems: "center", children: [
  /* @__PURE__ */ e.jsx(_, { item: !0, pr: 2, children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, textAlign: "center", mb: 1, children: /* @__PURE__ */ e.jsx(At, {}) }) }),
  /* @__PURE__ */ e.jsxs(_, { item: !0, flexGrow: 1, children: [
    t && /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, mb: 2, children: /* @__PURE__ */ e.jsx(se, { variant: "h3", children: t }) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(se, { variant: "body2", children: n }) })
  ] })
] }), eo = ({ onUpdate: t, hasDraftConceptModal: n }) => {
  var l, i;
  const { domains: s, status: a, error: r } = Fn(), [d, C] = U(Zs), h = (c, u) => {
    C((o) => ({ ...o, [c]: u || [] }));
  };
  return W(() => {
    t(
      Object.entries(d).reduce((c, [u, o]) => (u === "filter.domain" ? c[u] = o.map((E) => E.DOMAIN_ID) : c[u] = o, c), {})
    );
  }, [d]), /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, p: n ? 0 : 2, children: /* @__PURE__ */ e.jsx(je, { elevation: 0, children: /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, p: n ? 0 : 2, children: [
    /* @__PURE__ */ e.jsxs(_, { container: !0, spacing: 3, mb: 2, children: [
      /* @__PURE__ */ e.jsx(_, { item: !0, flexBasis: 300, children: /* @__PURE__ */ e.jsx(
        Fe,
        {
          fullWidth: !0,
          multiple: !0,
          id: "filter.domain",
          name: "filter.domain",
          placeholder: "Select Domains...",
          value: d["filter.domain"] || [],
          loading: a === m.IN_PROGRESS,
          options: s,
          onChange: (c, u) => {
            h("filter.domain", u);
          },
          getOptionLabel: function(c) {
            return c.DOMAIN_NAME;
          },
          isOptionEqualToValue: (c, u) => c.DOMAIN_ID === u.DOMAIN_ID,
          renderTags: () => {
            var c;
            return /* @__PURE__ */ e.jsx(
              en,
              {
                size: "small",
                label: ((c = d["filter.domain"]) == null ? void 0 : c.length) + " selected",
                sx: {
                  borderRadius: 0.5,
                  mx: 0.5,
                  height: 22,
                  fontSize: 12,
                  color: "textColor.primary"
                }
              }
            );
          }
        }
      ) }),
      /* @__PURE__ */ e.jsxs(_, { item: !0, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            size: "small",
            id: "filter.standard.concept",
            name: "filter.standard.concept",
            checked: ((l = d == null ? void 0 : d["filter.standard.concept"]) == null ? void 0 : l[0]) === "Standard",
            onChange: (c) => {
              const { name: u, checked: o } = c.target;
              h(u, o ? ["Standard"] : null);
            },
            sx: { mr: 1 }
          }
        ),
        /* @__PURE__ */ e.jsx(
          se,
          {
            component: "label",
            htmlFor: "filter.standard.concept",
            fontSize: 14,
            children: "Standard only"
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs(_, { item: !0, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            size: "small",
            id: "filter.invalid.reason",
            checked: ((i = d == null ? void 0 : d["filter.invalid.reason"]) == null ? void 0 : i[0]) === "Valid",
            name: "filter.invalid.reason",
            onChange: (c) => {
              const { name: u, checked: o } = c.target;
              h(u, o ? ["Valid"] : null);
            },
            sx: { mr: 1 }
          }
        ),
        /* @__PURE__ */ e.jsx(
          se,
          {
            component: "label",
            htmlFor: "filter.invalid.reason",
            fontSize: 14,
            children: "Valid only"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(qe, { sx: { borderColor: "borderColor.light" } }),
    /* @__PURE__ */ e.jsx(_, { item: !0, mt: 2, children: /* @__PURE__ */ e.jsx(
      Js,
      {
        title: "",
        description: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("b", { children: "OMOP Vocabularies" }),
          " store information about",
          " ",
          /* @__PURE__ */ e.jsx("b", { children: "Concepts" }),
          " which describe miscellaneous clinical events, such as demographics, visits, conditions, procedures, drugs, measurements, and more. One or more concepts can be assembled into a ",
          /* @__PURE__ */ e.jsx("b", { children: "Concept Set" }),
          " to specify a broader definition that can be used as a part of the cohort inclusion criteria definitions or as a part of the analysis design."
        ] })
      }
    ) })
  ] }) }) });
}, _n = ({
  draftSelectedConceptsCount: t,
  openSelectedArea: n,
  vocabularyMode: s,
  onSubmitAction: a,
  onRowClickAction: r,
  showOutlet: d = !0,
  replaceSearchParams: C = !1
}) => {
  const [h, l] = ge.useState(!0), [i, c] = Jn(), u = vt(
    (H) => H.user.data
  ), { state: o, status: E } = Nt(hs), T = cn(`${u.activeTenant}search`, {
    shortcut: !0,
    "created.timestamp": !0
  }), x = t != null, {
    search: p,
    filters: O,
    searchData: N,
    searchParams: { advancedSearch: A, searchFilters: j, searchQuery: b, pageNumber: P },
    pageCount: f,
    pageSize: I,
    totalElements: R,
    status: y,
    updateQuery: z,
    updateFilters: k,
    updateSearchParams: $,
    resetFilters: Y,
    updateAdvancedSearch: oe
  } = wt(null, null, null, T == null ? void 0 : T.storage), {
    selectedConcepts: ce,
    detectSelectedAction: le,
    clear: D,
    init: v,
    updateSelectedConceptBulk: S
  } = xe(), g = (H) => {
    const L = $n({
      ...zt(i),
      ...H
    });
    c(L, { replace: C });
  }, w = () => {
    Y(), c({}, { replace: C }), l(!0);
  }, G = (H, L) => {
    l(!1), g({
      fullSearch: H,
      advancedSearch: L
    }), z(H), oe(L);
  }, M = () => {
    a == null || a(ce), D();
  }, q = () => {
    D();
  }, pe = ({ original: H }) => {
    r == null || r(H);
  }, Ie = (H) => {
    g({
      pageNumber: H.pageIndex
    });
  }, X = (H) => {
    S(Array.isArray(H) ? H : [H]);
  }, Ce = B((H, L) => {
    const J = Te(H);
    le(J, L);
  }, []), Re = K(() => {
    const H = { ...j };
    return delete H.fullSearch, Object.values(H).some((L) => (L == null ? void 0 : L.length) > 0);
  }, [j]), { otherFilters: we } = Ze(
    O,
    "fullSearch"
  );
  return ge.useEffect(() => {
    var L;
    const H = zt(i);
    h && ((L = Object.values(H)) != null && L.length) && ($(H), l(!1));
  }, [i]), /* @__PURE__ */ e.jsxs(
    _,
    {
      container: !0,
      flexDirection: "column",
      flexWrap: "nowrap",
      minHeight: "inherit",
      children: [
        /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
          x && /* @__PURE__ */ e.jsx(
            Yn,
            {
              title: "Vocabulary",
              iconName: "vocabulary",
              customButtons: /* @__PURE__ */ e.jsxs(
                ae,
                {
                  onClick: n,
                  name: "open-draft-concept-set",
                  size: "large",
                  color: "info",
                  sx: {
                    span: {
                      fontWeight: "400",
                      textDecoration: "underline"
                    }
                  },
                  children: [
                    /* @__PURE__ */ e.jsx("span", { children: "Draft concept set" }),
                    /* @__PURE__ */ e.jsx(Ks, { className: "chip", children: t })
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx(
            qs,
            {
              container: !0,
              item: !0,
              xs: 12,
              py: x ? 2 : 0,
              className: "search-query-container",
              children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 9, children: /* @__PURE__ */ e.jsx(
                xn,
                {
                  initialQuery: b,
                  onFind: (H, L) => G(H, L),
                  onClear: w,
                  isInitial: h
                }
              ) })
            }
          ),
          h ? /* @__PURE__ */ e.jsx(
            eo,
            {
              onUpdate: (H) => {
                k(H);
              },
              hasDraftConceptModal: x
            }
          ) : /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, p: s ? 0 : 2, pb: 0, children: [
            /* @__PURE__ */ e.jsx(
              Pt,
              {
                onAdd: M,
                onClear: q,
                selectedConceptsCount: Object.keys(ce).length,
                buttonText: s ? "Add to draft concept set " : "Add to concept set ",
                width: t != null ? "calc(100% - 70px)" : window.innerWidth - 250 + "px"
              }
            ),
            /* @__PURE__ */ e.jsx(
              ue,
              {
                variant: "controlled",
                pageCount: f,
                pageIndex: P,
                pageSize: I,
                totalElements: R,
                data: N,
                getRowId: (H) => String(H.conceptId),
                selectedConcepts: ce,
                onRowSelect: Ce,
                onEdit: X,
                onRowClick: pe,
                setPagination: Ie,
                fetchData: p,
                onSelectAll: v,
                status: y,
                storage: T,
                hasRcDrcSelect: !0,
                hasDraftConceptModal: !0,
                enableRowSelection: !0,
                noGaps: s,
                showFilterToggle: !0,
                hasFilters: Re,
                children: /* @__PURE__ */ e.jsx(
                  Ke,
                  {
                    showLabel: !0,
                    filters: we,
                    value: j,
                    onChange: (H, L) => {
                      const J = { [H]: L };
                      g(J), k(J), T == null || T.setStorage("filters", {
                        ...j,
                        ...J
                      });
                    },
                    isLoading: y === m.IN_PROGRESS,
                    isReloading: y === m.IN_PROGRESS_RELOAD
                  }
                )
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          _,
          {
            item: !0,
            xs: 12,
            sx: {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              mb: 1
            },
            children: /* @__PURE__ */ e.jsx(se, { variant: "subtitle2", px: 2, color: "primary.light", children: "Vocabulary version: " + o })
          }
        ),
        d && /* @__PURE__ */ e.jsx(es, {})
      ]
    }
  );
};
function gn(t, n = "conceptId") {
  const [s, a] = U(m.INITIAL), [r, d] = U({}), C = async (h) => {
    if (s !== m.IN_PROGRESS) {
      a(m.IN_PROGRESS);
      try {
        const l = await hn(
          Object.values(h).map((c) => c.conceptId)
        ).catch((c) => (console.error("LOAD CONCEPT LIST ERROR:", c), [])), i = Ne(
          Object.values(h).map((c, u) => ({
            ...c,
            concept: {
              ...c.concept,
              ...l[u]
            }
          })),
          n
        );
        return a(m.SUCCESS), d(Object.values(i)), i;
      } catch (l) {
        console.error(l), a(m.ERROR);
      }
    }
  };
  return W(() => {
    Object.keys(t || {}).length > 0 ? C(t) : Object.keys(t || {}).length === 0 && d({});
  }, [t]), {
    status: s,
    concepts: r,
    loadConceptsData: C
  };
}
const to = (t) => {
  const {
    concepts: n,
    onClose: s,
    onChange: a,
    onChangeBulk: r,
    subModules: d,
    pureClose: C,
    path: h
  } = t, l = Ge(), { status: i, concepts: c, loadConceptsData: u } = gn(n), { selectedConcepts: o, detectSelectedAction: E, clear: T } = xe({}, "conceptId"), x = !Object.keys(o).length, p = !Object.keys(n).length, O = (b) => {
    a(Array.isArray(b) ? b : [b]);
  }, N = () => {
    const b = Object.values(n).reduce((P, f) => (o[f.conceptId] || (P[f.conceptId] = f), P), {});
    r(b), T();
  }, A = B((b, P) => {
    const f = Te(b);
    E(f, P);
  }, []), j = () => {
    s == null || s();
  };
  return /* @__PURE__ */ e.jsx(_, { container: !0, children: /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(bt, { onClose: C, children: "Draft concept set" }),
    /* @__PURE__ */ e.jsx(je, { elevation: 3, children: /* @__PURE__ */ e.jsx(
      d.concept,
      {
        type: "component",
        name: "widget-concept-set-save",
        path: "/concept-sets",
        subModules: d,
        config: {
          concepts: c,
          onSave: j,
          disableActions: p
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(_, { container: !0, children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(Qe, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(_, { container: !0, children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      ue,
      {
        storageKey: "concept-set-draft",
        showFilterToggle: !0,
        disableEdit: !1,
        data: Object.values(c),
        enableRowSelection: !0,
        getRowId: (b) => String(b.conceptId),
        onRowSelect: A,
        onEdit: O,
        onRowClick: (b) => {
          l(
            `/${h}/modal/related/${b.original.conceptId}`,
            {
              state: {
                closeTo: `/${h}/modal/selected`
              }
            }
          );
        },
        pageIndex: 0,
        selectedConcepts: o,
        title: "Selected concepts",
        status: i,
        reloadData: () => {
          u(n);
        },
        hasRcDrc: !0,
        variant: "uncontrolled",
        enableFiltering: !0,
        hasRcDrcSelect: !0,
        customActions: /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
          ae,
          {
            variant: "outlined",
            disabled: x,
            onClick: N,
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "delete" }),
            endIcon: /* @__PURE__ */ e.jsxs(F, { component: "span", sx: { fontSize: 11 }, children: [
              "(",
              Object.keys(o).length || 0,
              ")"
            ] }),
            name: "delete-selected",
            color: "error",
            sx: { ml: 1 },
            children: "Delete selected"
          }
        ) }),
        filtersDefaultClosed: !0
      }
    ) }) }) }) }) })
  ] }) });
}, no = (t) => {
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: r,
    selectedConcepts: d,
    filtersAncestors: C,
    relatedAncestors: h,
    isNativeHierarchy: l,
    viewMode: i
  } = t, { data: c, form: u, setFilters: o, resetFilters: E, updateFilters: T, status: x } = C, {
    concepts: p,
    pageCount: O,
    totalElements: N,
    numberOfElements: A,
    getRelated: j,
    status: b
  } = h;
  W(() => (o(
    is(n, l),
    Xe
  ), () => {
    E();
  }), []);
  const P = (y) => {
    a(Array.isArray(y) ? y : [y]);
  }, f = Object.values(u).some(
    (y) => (y == null ? void 0 : y.length) > 0
  ), { otherFilters: I, searchFilter: R } = Ze(
    c,
    "fullSearch"
  );
  return /* @__PURE__ */ e.jsx(
    ue,
    {
      variant: "controlled",
      storageKey: "concept-ancestors",
      disableEdit: !0,
      showFilterToggle: !0,
      hasHierarchy: !i,
      enableRowSelection: !i,
      title: "Ancestors",
      pageCount: O,
      totalElements: N,
      data: p,
      getRowId: (y) => String(y.conceptId),
      selectedConcepts: d,
      onRowSelect: r,
      onEdit: P,
      onRowClick: s,
      onSelectAll: (y) => r(Object.values(y), y),
      fetchData: j,
      status: b,
      hasRcDrcSelect: !0,
      collapsible: !0,
      outlined: !0,
      pageIndex: 0,
      noDataText: f ? "The result listing is empty because of the filter you applied" : "No data currently available",
      hasFilters: f,
      searchComponent: R && /* @__PURE__ */ e.jsx(
        Et,
        {
          ...R,
          value: u == null ? void 0 : u[R == null ? void 0 : R.name],
          onChange: (y) => T(R == null ? void 0 : R.name, y)
        }
      ),
      children: /* @__PURE__ */ e.jsx(
        Ke,
        {
          showLabel: !0,
          filters: I,
          value: u,
          onChange: T,
          isReloading: x === m.IN_PROGRESS_RELOAD || b === m.IN_PROGRESS_RELOAD,
          isLoading: x === m.IN_PROGRESS || b === m.IN_PROGRESS || b === m.INITIAL
        }
      )
    }
  );
}, so = (t) => {
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: r,
    selectedConcepts: d,
    filtersDescendants: C,
    relatedDescendants: h,
    isNativeHierarchy: l,
    viewMode: i
  } = t, { data: c, form: u, setFilters: o, resetFilters: E, updateFilters: T, status: x } = C, {
    concepts: p,
    pageCount: O,
    totalElements: N,
    numberOfElements: A,
    getRelated: j,
    status: b
  } = h;
  W(() => (o(
    ds(n, l),
    Xe
  ), () => {
    E();
  }), []);
  const P = (y) => {
    a(Array.isArray(y) ? y : [y]);
  }, f = Object.values(u).some(
    (y) => (y == null ? void 0 : y.length) > 0
  ), { otherFilters: I, searchFilter: R } = Ze(
    c,
    "fullSearch"
  );
  return /* @__PURE__ */ e.jsx(ge.Fragment, { children: /* @__PURE__ */ e.jsx(
    ue,
    {
      variant: "controlled",
      storageKey: "concept-descendants",
      disableEdit: !0,
      showFilterToggle: !0,
      hasHierarchy: !i,
      enableRowSelection: !i,
      title: "Descendants",
      pageCount: O,
      totalElements: N,
      data: p,
      getRowId: (y) => String(y.conceptId),
      selectedConcepts: d,
      onRowSelect: r,
      onEdit: P,
      onRowClick: s,
      onSelectAll: (y) => r(Object.values(y), y),
      fetchData: j,
      status: b,
      hasRcDrcSelect: !0,
      pageIndex: 0,
      collapsible: !0,
      outlined: !0,
      noDataText: f ? "The result listing is empty because of the filter you applied" : "No data currently available",
      hasFilters: f,
      searchComponent: R && /* @__PURE__ */ e.jsx(
        Et,
        {
          ...R,
          value: u == null ? void 0 : u[R == null ? void 0 : R.name],
          onChange: (y) => T(R == null ? void 0 : R.name, y)
        }
      ),
      children: /* @__PURE__ */ e.jsx(
        Ke,
        {
          showLabel: !0,
          filters: I,
          value: u,
          onChange: T,
          isReloading: x === m.IN_PROGRESS_RELOAD || b === m.IN_PROGRESS_RELOAD,
          isLoading: x === m.IN_PROGRESS || b === m.IN_PROGRESS || b === m.INITIAL
        }
      )
    }
  ) });
}, oo = {
  relatedIds: {
    data: [],
    status: m.INITIAL
  },
  relatedConceptsPageData: {
    rawData: [],
    data: [],
    status: m.INITIAL
  },
  filters: {
    data: [],
    form: {},
    status: m.INITIAL
  },
  status: m.INITIAL,
  pageCount: 0,
  totalElements: 0,
  numberOfElements: 0,
  sortBy: void 0
};
function ao(t, n) {
  return Pe(t, (s) => {
    var a, r;
    switch (n.type) {
      case "GET_RELATED_IDS": {
        s.relatedIds.status = s.relatedIds.status === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD, s.status = s.status === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD, s.filters.status = s.filters.status === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD;
        break;
      }
      case "GET_RELATED_IDS_SUCCESS": {
        s.relatedIds.status = m.SUCCESS, s.relatedIds.data = n.payload.concepts, s.totalElements = ((a = n.payload.concepts) == null ? void 0 : a.length) || 0, s.sortBy = ((r = n.payload) == null ? void 0 : r.sortBy) || void 0;
        break;
      }
      case "GET_FILTERS_SUCCESS": {
        s.filters.data = n.payload.filters, s.filters.status = m.SUCCESS;
        break;
      }
      case "GET_RELATED_IDS_ERROR": {
        s.relatedIds.status = m.ERROR;
        break;
      }
      case "GET_RELATED_CONCEPTS": {
        s.relatedConceptsPageData.status = m.IN_PROGRESS, s.status = s.status === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD;
        break;
      }
      case "GET_RELATED_CONCEPTS_SUCCESS": {
        s.relatedConceptsPageData.data = n.payload.data, s.relatedConceptsPageData.rawData = n.payload.rawData, s.pageCount = Math.ceil(
          t.totalElements / n.payload.pageSize
        ), s.relatedConceptsPageData.status = m.SUCCESS, s.status = m.SUCCESS;
        break;
      }
      case "GET_RELATED_CONCEPTS_ERROR": {
        s.relatedConceptsPageData.status = m.ERROR, s.status = m.ERROR;
        break;
      }
      case "UPDATE_FILTERS": {
        const { key: d, value: C } = n.payload;
        s.filters.form[d] = C;
        break;
      }
    }
  });
}
function ro(t) {
  const [n, s] = Ae(
    ao,
    oo
  ), a = (C, h) => {
    s({
      type: "UPDATE_FILTERS",
      payload: { key: C, value: h }
    });
  }, r = B(
    async (C) => {
      if (t != null) {
        s({
          type: "GET_RELATED_IDS"
          /* GET_RELATED_IDS */
        });
        try {
          const h = St(n.filters.form);
          ps(t, h, C).then((l) => {
            s({
              type: "GET_RELATED_IDS_SUCCESS",
              payload: { concepts: l, sortBy: C }
            });
          }), Cs(t)(h).then(Xe).then((l) => {
            s({
              type: "GET_FILTERS_SUCCESS",
              payload: { filters: l }
            });
          });
        } catch (h) {
          console.error(h);
        }
      }
    },
    [t, n.filters.form]
  ), d = B(
    async (C = 0, h = 10, l, i = !1) => {
      const c = async (u) => {
        const o = await hn(u);
        return { data: o.map(
          (T) => ve(T)
        ), rawData: o };
      };
      if (i) {
        const u = n.relatedIds.data.map((E) => E.id), { data: o } = await c(u);
        return Ne(o, "conceptId");
      } else if (Me(l, n.sortBy)) {
        if (n.relatedIds.status === m.SUCCESS) {
          s({
            type: "GET_RELATED_CONCEPTS"
            /* GET_RELATED_CONCEPTS */
          });
          try {
            const o = n.relatedIds.data.slice(C * h, C * h + h).map((x) => x.id), { data: E, rawData: T } = await c(o);
            s({
              type: "GET_RELATED_CONCEPTS_SUCCESS",
              payload: {
                rawData: T,
                data: E,
                pageSize: h,
                pageNumber: C
              }
            });
          } catch (o) {
            console.error(o);
          }
        }
      } else
        r(l);
    },
    [n.relatedIds.data]
  );
  return W(() => {
    r();
  }, [r]), { ...n, getRelatedConcepts: d, updateFilters: a };
}
const co = (t) => {
  var o;
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: r,
    selectedConcepts: d,
    viewMode: C
  } = t, h = ro(n), l = (E) => {
    a(Array.isArray(E) ? E : [E]);
  }, i = Object.values(h.filters.form).some(
    (E) => (E == null ? void 0 : E.length) > 0
  ), { otherFilters: c, searchFilter: u } = Ze(
    h.filters.data
  );
  return /* @__PURE__ */ e.jsx(
    ue,
    {
      variant: "controlled",
      storageKey: "concept-related",
      disableEdit: !0,
      showFilterToggle: !0,
      hasHierarchy: !C,
      enableRowSelection: !C,
      pageCount: h.pageCount,
      totalElements: h.totalElements,
      data: h.relatedConceptsPageData.data,
      getRowId: (E) => String(E.conceptId),
      selectedConcepts: d,
      onRowSelect: r,
      onEdit: l,
      onSelectAll: (E) => r(Object.values(E), E),
      onRowClick: s,
      fetchData: h.getRelatedConcepts,
      status: h.status,
      hasRcDrcSelect: !0,
      pageIndex: 0,
      outlined: !0,
      hasFilters: i,
      searchComponent: u && /* @__PURE__ */ e.jsx(
        Et,
        {
          ...u,
          value: (o = h.filters.form) == null ? void 0 : o[u == null ? void 0 : u.name],
          onChange: (E) => h.updateFilters(u == null ? void 0 : u.name, E)
        }
      ),
      children: /* @__PURE__ */ e.jsx(
        Ke,
        {
          showLabel: !0,
          filters: c,
          value: h.filters.form,
          onChange: h.updateFilters,
          isReloading: h.filters.status === m.IN_PROGRESS_RELOAD,
          isLoading: h.filters.status === m.IN_PROGRESS || h.filters.status === m.INITIAL
        }
      )
    }
  );
}, lo = {
  selectedConcepts: {},
  objectConcepts: {},
  status: m.INITIAL,
  updateStatus: m.INITIAL
};
var V = /* @__PURE__ */ ((t) => (t.INIT_CONCEPT_PROGRESS = "INIT_CONCEPT_PROGRESS", t.REINITIAL_CONCEPTS = "REINITIAL_CONCEPTS", t.SET_INITIAL_STATE = "SET_INITIAL_STATE", t.ADD_SELECTED_CONCEPT = "ADD_SELECTED_CONCEPT", t.REMOVE_SELECTED_CONCEPT = "REMOVE_SELECTED_CONCEPT", t.UPDATE_CONCEPT = "UPDATE_CONCEPT", t.UPDATE_CONCEPT_BULK = "UPDATE_CONCEPT_BULK", t.UPDATE_CONCEPT_PROGRESS = "UPDATE_CONCEPT_PROGRESS", t.REMOVE_CONCEPT_PROGRESS = "REMOVE_CONCEPT_PROGRESS", t.CREATE_CONCEPT_PROGRESS = "CREATE_CONCEPT_PROGRESS", t.REMOVE_CONCEPT = "REMOVE_CONCEPT", t.CREATE_CONCEPT = "CREATE_CONCEPT", t.LOAD_CONCEPTS = "LOAD_CONCEPTS", t.LOAD_CONCEPTS_SUCCESS = "LOAD_CONCEPTS_SUCCESS", t.LOAD_CONCEPTS_ERROR = "LOAD_CONCEPTS_ERROR", t.OVERWRITE_CONCEPT_SET_PROGRESS = "OVERWRITE_CONCEPT_SET_PROGRESS", t.OVERWRITE_CONCEPT_SET = "OVERWRITE_CONCEPT_SET", t))(V || {});
const io = (t, n) => Pe(
  t,
  (s) => {
    switch (n.type) {
      case V.CREATE_CONCEPT_PROGRESS:
        s.status = m.IN_PROGRESS;
        break;
      case V.CREATE_CONCEPT:
        s.objectConcepts = {
          ...n.payload.concepts,
          ...s.objectConcepts
        }, s.status = m.SUCCESS;
        break;
      case V.UPDATE_CONCEPT_PROGRESS:
        s.updateStatus = m.IN_PROGRESS;
        break;
      case V.UPDATE_CONCEPT:
        s.objectConcepts[n.payload.concept.id] = n.payload.concept, s.updateStatus = m.SUCCESS;
        break;
      case V.UPDATE_CONCEPT_BULK:
        for (const a of n.payload) {
          const r = a.id ?? yt();
          s.objectConcepts[r] = { ...a, id: r };
        }
        s.updateStatus = m.SUCCESS;
        break;
      case V.REINITIAL_CONCEPTS:
        s.objectConcepts = n.payload;
        break;
      case V.REMOVE_CONCEPT_PROGRESS:
        s.status = m.IN_PROGRESS;
        break;
      case V.REMOVE_CONCEPT:
        Object.keys(n.payload).forEach((a) => {
          delete s.objectConcepts[a];
        }), s.selectedConcepts = {}, s.status = m.SUCCESS;
        break;
      case V.REMOVE_SELECTED_CONCEPT:
        delete s.selectedConcepts[n.payload.id], s.status = m.SUCCESS;
        break;
      case V.LOAD_CONCEPTS:
        s.status = m.IN_PROGRESS;
        break;
      case V.LOAD_CONCEPTS_SUCCESS:
        s.objectConcepts = n.payload, s.status = m.SUCCESS;
        break;
      case V.OVERWRITE_CONCEPT_SET_PROGRESS:
        s.status = m.IN_PROGRESS;
        break;
      case V.OVERWRITE_CONCEPT_SET:
        s.objectConcepts = n.payload, s.status = m.SUCCESS;
        break;
    }
  }
), uo = (t, n = "embedded") => {
  const [s, a] = Ae(
    io,
    {
      ...lo,
      objectConcepts: t,
      status: n === "stand-alone" ? m.SUCCESS : m.INITIAL
    }
  ), { status: r, loadConceptsData: d } = gn(), C = B(
    async (E) => {
      a({ type: V.CREATE_CONCEPT_PROGRESS }), a({
        type: V.CREATE_CONCEPT,
        payload: {
          concepts: Tt(E)
        }
      });
    },
    []
  ), h = B((E) => {
    a({
      type: V.UPDATE_CONCEPT_PROGRESS
    }), setTimeout(() => {
      a({
        type: V.UPDATE_CONCEPT,
        payload: {
          concept: {
            ...E,
            //  we should probably start working with CONCEPT_ID s instead of generating random
            id: E.id
          }
          // id: concept.id ?? getUUID(),
        }
      });
    }, 100);
  }, []), l = (E) => {
    a({
      type: V.REINITIAL_CONCEPTS,
      payload: E
    });
  }, i = (E) => {
    a({
      type: V.UPDATE_CONCEPT_PROGRESS
    }), setTimeout(() => {
      a({
        type: V.UPDATE_CONCEPT_BULK,
        payload: E
      });
    }, 100);
  }, c = B((E) => {
    a({
      type: V.REMOVE_CONCEPT_PROGRESS
    }), setTimeout(() => {
      a({
        type: V.REMOVE_CONCEPT,
        payload: E
      });
    }, 300);
  }, []), u = async (E = t) => {
    a({ type: V.LOAD_CONCEPTS });
    try {
      const T = await d(E);
      a({
        type: V.LOAD_CONCEPTS_SUCCESS,
        payload: Tt(T)
      });
    } catch (T) {
      console.error(T);
    }
  }, o = (E) => {
    a({
      type: V.OVERWRITE_CONCEPT_SET_PROGRESS
    }), setTimeout(() => {
      a({
        type: V.OVERWRITE_CONCEPT_SET,
        payload: Ne(E, "id")
      });
    }, 100);
  };
  return W(() => {
    n === "embedded" && s.status === m.INITIAL && u(t);
  }, [t, n]), {
    ...s,
    loadStatus: r,
    createConcepts: C,
    updateConcept: h,
    removeConcepts: c,
    updateConceptsBulk: i,
    reloadConceptData: u,
    reinitialConcepts: l,
    overwriteConceptSet: o
  };
};
var Oe = /* @__PURE__ */ ((t) => (t.GET_CONCEPTS_REQUEST = "GET_CONCEPTS_REQUEST", t.GET_CONCEPTS_REQUEST_DONE = "GET_CONCEPTS_REQUEST_DONE", t.GET_CONCEPTS_REQUEST_FAILED = "GET_CONCEPTS_REQUEST_FAILED", t.SET_FILTERS_QUERY = "SET_FILTERS_QUERY", t))(Oe || {});
const po = (t, n) => Pe(t, (s) => {
  switch (n.type) {
    case Oe.GET_CONCEPTS_REQUEST:
      s.status = s.status === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD;
      break;
    case Oe.GET_CONCEPTS_REQUEST_DONE:
      s.concepts = n.payload.content, s.pageCount = n.payload.totalPages || 1, s.totalElements = n.payload.totalElements, s.numberOfElements = n.payload.numberOfElements, s.status = m.SUCCESS;
      break;
    case Oe.SET_FILTERS_QUERY:
      s.filtersQuery = n.payload;
      break;
  }
}), Co = {
  concepts: [],
  error: null,
  pageCount: 1,
  totalElements: 0,
  numberOfElements: 0,
  filtersQuery: "",
  status: m.INITIAL
}, qt = (t, n, s, a) => {
  const [r, d] = Ae(
    po,
    Co
  ), C = B(
    async (l = 0, i = 10, c, u = !1) => {
      u || d({
        type: Oe.GET_CONCEPTS_REQUEST
      });
      try {
        const o = await cs(n, s, t, {
          pageNumber: l,
          pageSize: i,
          sortBy: c,
          query: r.filtersQuery
        }), E = o.content.map(
          (x) => ve(x)
        );
        if (u)
          return Ne(E, "conceptId");
        const T = {
          ...o,
          content: E
        };
        d({
          type: Oe.GET_CONCEPTS_REQUEST_DONE,
          payload: T
        });
      } catch (o) {
        d({
          type: Oe.GET_CONCEPTS_REQUEST_FAILED,
          payload: o
        });
      }
    },
    [t, r.filtersQuery]
  ), h = B((l) => {
    l && d({
      type: Oe.SET_FILTERS_QUERY,
      payload: St(l)
    });
  }, []);
  return W(() => {
    h(a);
  }, [a]), W(() => {
    C();
  }, []), {
    ...r,
    setFiltersQuery: h,
    getRelated: C
  };
};
var de = /* @__PURE__ */ ((t) => (t.SEARCH_REQUEST = "SEARCH_REQUEST", t.SEARCH_REQUEST_DONE = "SEARCH_REQUEST_DONE", t.UPDATE_FILTERS = "UPDATE_FILTERS", t.RESET_FILTERS = "RESET_FILTERS", t.FILTERS_REQUEST = "FILTERS_REQUEST", t.FILTERS_REQUEST_DONE = "FILTERS_REQUEST_DONE", t))(de || {});
const ho = (t, n) => Pe(t, (s) => {
  switch (n.type) {
    case de.SEARCH_REQUEST:
      s.status = s.status === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD;
      break;
    case de.SEARCH_REQUEST_DONE:
      s.includedItems = n.payload.data.content, s.pageCount = n.payload.data.totalPages || 1, s.pageNumber = n.payload.data.number || 0, s.numberOfElements = n.payload.data.numberOfElements, s.totalElements = n.payload.data.totalElements, s.status = m.SUCCESS;
      break;
    case de.FILTERS_REQUEST:
      s.filtersStatus = s.filtersStatus === m.INITIAL ? m.IN_PROGRESS : m.IN_PROGRESS_RELOAD;
      break;
    case de.FILTERS_REQUEST_DONE:
      s.filters = n.payload.filters, s.filtersStatus = m.SUCCESS;
      break;
    case de.UPDATE_FILTERS:
      s.filtersForm = { ...s.filtersForm, ...n.payload };
      break;
    case de.RESET_FILTERS:
      s.filtersForm = [];
      break;
  }
}), Eo = {
  searchQuery: "",
  pageCount: 1,
  pageNumber: 0,
  pageSize: 10,
  numberOfElements: 0,
  totalElements: 0,
  includedItems: [],
  status: m.INITIAL,
  filters: [],
  filtersForm: {},
  filtersStatus: m.INITIAL
}, So = (t, n) => {
  const [s, a] = Ae(
    ho,
    Eo
  ), r = (h) => {
    a({
      type: de.UPDATE_FILTERS,
      payload: h
    });
  }, d = () => {
    a({
      type: de.RESET_FILTERS
    });
  }, C = B(
    async (h = s.pageNumber, l = s.pageSize, i, c = !1) => {
      if (c || (a({ type: de.SEARCH_REQUEST }), a({ type: de.FILTERS_REQUEST })), {
        fullSearch: [s.searchQuery, `${s.searchQuery}*`]
      })
        try {
          const o = {
            query: St(s.filtersForm),
            pageNumber: h,
            pageSize: l,
            sortBy: i
          }, E = t.get(o, n).then((T) => {
            let x = [];
            T && (x = T.content.map(
              (O) => ve(O)
            ));
            const p = {
              ...T,
              content: x
            };
            if (c)
              return Ne(x, "conceptId");
            a({
              type: de.SEARCH_REQUEST_DONE,
              payload: { data: p }
            });
          });
          if (c)
            return await E;
          t.getFilters(o, n).then((T) => {
            a({
              type: de.FILTERS_REQUEST_DONE,
              payload: {
                filters: T ? Xe(T) : []
              }
            });
          });
        } catch (o) {
          console.error(o);
        }
    },
    [s.searchQuery, s.filtersForm]
  );
  return {
    ...s,
    fetchIncluded: C,
    updateFilters: r,
    resetFilters: d
  };
};
var ie = /* @__PURE__ */ ((t) => (t.UPDATE_IDENTIFIERS = "UPDATE_IDENTIFIERS", t.UPDATE_SOURCE_CODES = "UPDATE_SOURCE_CODES", t.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST = "ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST", t.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST = "ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST", t.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE = "ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE", t.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST_DONE = "ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST_DONE", t.SWITCH_CHECK_MODE = "SWITCH_CHECK_MODE", t))(ie || {});
const mo = (t, n) => Pe(t, (s) => {
  switch (n.type) {
    case ie.UPDATE_IDENTIFIERS:
      s.identifiers = n.payload;
      break;
    case ie.UPDATE_SOURCE_CODES:
      s.sourceCodes = n.payload;
      break;
    case ie.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST:
    case ie.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST:
      s.isCompleteDownload = !1;
      break;
    case ie.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE:
    case ie.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST_DONE:
      s.isCompleteDownload = !0, s.objectExtendConcepts = n.payload;
      break;
    case ie.SWITCH_CHECK_MODE:
      s.checkState = n.payload;
      break;
  }
}), xo = {
  identifiers: "",
  sourceCodes: "",
  isCompleteDownload: !1,
  objectExtendConcepts: {},
  checkState: !1,
  extendOptions: {}
}, _o = () => {
  const [t, n] = Ae(
    mo,
    xo
  ), s = (l) => {
    n({
      type: ie.UPDATE_IDENTIFIERS,
      payload: l
    });
  }, a = (l) => {
    n({
      type: ie.UPDATE_SOURCE_CODES,
      payload: l
    });
  }, r = (l, i) => {
    switch (l) {
      case ze.IDENTIFIERS:
        s(i);
        break;
      case ze.SOURCE_CODES:
        a(i);
        break;
    }
  }, d = B(
    async (l) => {
      n({
        type: ie.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST
      });
      try {
        n({
          type: ie.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE,
          payload: l
        });
      } catch {
      }
    },
    [t.identifiers]
  );
  return {
    ...t,
    updateIds: r,
    addConcepts: (l) => {
      d(l);
    },
    switchCheckMode: (l) => {
      n({
        type: ie.SWITCH_CHECK_MODE,
        payload: l
      });
    }
  };
}, Kt = (t) => {
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: r,
    selectedConcepts: d,
    isNativeHierarchy: C,
    viewMode: h
  } = t, l = Ut(), i = Ut(), c = qt(
    n,
    Ht.ANCESTORS,
    C,
    l.form
  ), u = qt(
    n,
    Ht.DESCENDANTS,
    C,
    i.form
  );
  return /* @__PURE__ */ e.jsxs(
    F,
    {
      sx: {
        ".collapsible-block": {
          mb: 1
        }
      },
      children: [
        /* @__PURE__ */ e.jsx(
          no,
          {
            id: n,
            onChangeConcept: a,
            onClickConcept: s,
            onSelectConcept: r,
            selectedConcepts: d,
            filtersAncestors: l,
            relatedAncestors: c,
            isNativeHierarchy: C,
            viewMode: h
          }
        ),
        /* @__PURE__ */ e.jsx(
          so,
          {
            id: n,
            onChangeConcept: a,
            onClickConcept: s,
            onSelectConcept: r,
            selectedConcepts: d,
            filtersDescendants: i,
            relatedDescendants: u,
            isNativeHierarchy: C,
            viewMode: h
          }
        )
      ]
    }
  );
};
Q.div`
  padding: 15px 20px;
  .concept-details__row {
    font-size: ${({ theme: t }) => {
  var n;
  return (n = t.typography) == null ? void 0 : n.fontSize;
}}px;
    border-bottom: 1px solid #dae1ee;
    padding: 8px;
    :hover {
      background-color: #dae1ee;
    }
  }
  .concept-details__row-heading {
    font-weight: bold;
    background-color: #dae1ee;
  }
  white-space: pre-wrap;
`;
Q.div`
  color: ${({ color: t }) => t};
  margin-top: 11px;
  display: inline-block;
  /* font-weight:700; */
`;
const go = Q.span`
  margin-right: 20px;
  position: relative;
  display: flex;
  align-items: center;
  .status-tag {
    margin-left: 8px;
  }
`;
Q.div`
  padding: 20px 20px 0;
  /* box-shadow: ${({ theme: t }) => t.customShadows[2]}; */

  // border-bottom: 3px solid #d8e1ef;
  .item:not(.active-item) {
    background-color: #ffffff;
  }
  > * {
    margin-bottom: 0;
  }
`;
const fo = Q(ae)`
  margin-left: 16px;
`;
Q(ae)`
  margin-left: 20px;
  height: 35px;
  font-size: 12px;
  font-weight: 700;
  border: none;
  background: #ffffff !important;
  color: #8fcb54;
  border-radius: 4px;
`;
Q.div`
  position: relative;
`;
Q.div`
  position: absolute;
  right: 0;
  /* TODO */
  bottom: 31px;
  margin-right: 10px;
`;
Q(ln)`
  height: 40px;
  font-size: 12px;
  margin-top: 2px;
  .selected-title {
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    text-decoration: underline;
    padding-right: 5px;
  }
  .selected-count {
    background: #e1ecf3;
    width: 23px;
    display: inline-block;
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    padding: 4px 2px;
  }
`;
const To = (t, n) => {
  const s = n ? {
    value: De.NATIVE_HIERARCHY,
    title: "Source Hierarchy",
    onTabClick: t
  } : {
    value: De.HIERARCHY,
    title: "OMOP Hierarchy",
    onTabClick: t
  };
  return [
    {
      value: De.RELATED_CONCEPTS,
      title: "Related concepts",
      onTabClick: t
    },
    s
  ];
}, mt = fe((t) => {
  const {
    onClose: n,
    onFind: s,
    pureClose: a,
    conceptId: r,
    entryConcept: d,
    subModules: C,
    vocabularyMode: h,
    path: l,
    viewMode: i,
    typeContainer: c,
    parentId: u,
    canEdit: o = !0
  } = t, E = localStorage.getItem(
    "currentConceptSetItem"
  ), T = Ge(), x = Je(), { conceptId: p } = ts(), O = r || p, [N, A] = U(null);
  ge.useEffect(() => {
    d && A(d);
  }, [d]), ge.useEffect(() => {
    O && us(O).then((g) => {
      A(ve(g));
    });
  }, [O]);
  const [j, b] = U(
    De.RELATED_CONCEPTS
  ), [P, f] = U(!1), { enqueueSnackbar: I } = ht(), {
    selectedConcepts: R,
    updateSelectedConceptBulk: y,
    detectSelectedAction: z,
    clear: k
  } = xe(), $ = K(() => To(
    b,
    !(N != null && N.concept.STANDARD_CONCEPT)
  ), [N]), Y = (g) => /* @__PURE__ */ e.jsxs(_, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
      g ? "Concepts" : "Concept",
      " added to draft concept set"
    ] }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ns, { to: `/${l}/modal/selected`, children: /* @__PURE__ */ e.jsxs("b", { children: [
      "Navigate to draft concept set ",
      ">>"
    ] }) }) })
  ] }), oe = (g) => {
    s == null || s({
      [g.id]: g,
      ...R
    }), f(!0), I({
      message: h ? Y(!1) : "Concept added to concept set",
      variant: "success"
    });
  }, ce = () => {
    s == null || s(R), k(), I({
      message: h ? Y(!0) : "Concepts added to concept set",
      variant: "success"
    });
  }, le = ({
    original: g
  }) => {
    T(`/${l}/modal/related/${g.conceptId}`, {
      state: x.state
    }), f(!1);
  }, D = (g) => {
    const { color: w } = at(g);
    return w;
  }, v = B((g, w) => {
    const G = Te(g);
    z(G, w);
  }, []), S = Object.keys(R).length;
  return N && /* @__PURE__ */ e.jsxs(
    _,
    {
      container: !0,
      height: "100vh",
      sx: { overflowY: "auto" },
      alignContent: "flex-start",
      children: [
        /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, position: "sticky", zIndex: 3, top: "0", children: [
          /* @__PURE__ */ e.jsx(bt, { onClose: a || n, children: /* @__PURE__ */ e.jsxs(_, { container: !0, spacing: 1, alignItems: "center", children: [
            /* @__PURE__ */ e.jsx(_, { item: !0, width: 50, children: /* @__PURE__ */ e.jsx(
              ae,
              {
                sx: { minWidth: 0, padding: 1 },
                variant: "contained",
                color: "secondary",
                onClick: () => {
                  T(-1);
                },
                children: /* @__PURE__ */ e.jsx(
                  te,
                  {
                    iconName: "chevron",
                    sx: { transform: "rotate(90deg)" }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(
              _,
              {
                item: !0,
                flexGrow: 1,
                display: "flex",
                width: "calc(100% - 50px)",
                children: /* @__PURE__ */ e.jsxs(go, { children: [
                  N.concept.CONCEPT_NAME,
                  " ",
                  /* @__PURE__ */ e.jsx(
                    tn,
                    {
                      text: N.concept.STANDARD_CONCEPT_CAPTION,
                      color: D(
                        N.concept.STANDARD_CONCEPT
                      ),
                      align: "center"
                    }
                  )
                ] })
              }
            )
          ] }) }),
          /* @__PURE__ */ e.jsx(
            Is,
            {
              canEdit: o,
              concept: N,
              onEditAction: A,
              clearConceptSettings: P
            }
          ),
          /* @__PURE__ */ e.jsx(
            C.concept,
            {
              type: "component",
              name: "widget-concept-set-save",
              path: "/concept-sets",
              subModules: C,
              config: {
                typeContainer: c,
                parentId: u,
                concepts: [N],
                // TODO: finish later
                onSave: () => {
                },
                component: () => {
                  if (!i)
                    return (h || !h && O !== E) && /* @__PURE__ */ e.jsx(
                      fo,
                      {
                        onClick: () => oe(N),
                        name: "add-to-concept-set",
                        variant: "contained",
                        color: "success",
                        children: h ? "Add to draft concept set " : "Add to concept set"
                      }
                    );
                }
              }
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(je, { elevation: 3, sx: { borderRadius: 0 }, children: /* @__PURE__ */ e.jsx(dn, { tabs: $, active: j }) }) }),
        /* @__PURE__ */ e.jsxs(
          _,
          {
            item: !0,
            xs: 12,
            container: !0,
            alignContent: "flex-start",
            p: 2,
            mb: S === 0 ? 0 : 6,
            children: [
              /* @__PURE__ */ e.jsx(
                Pt,
                {
                  selectedConceptsCount: S,
                  width: window.innerWidth - 250 + "px",
                  onAdd: ce,
                  onClear: k,
                  buttonText: h ? "Add to draft concept set " : "Add to concept set "
                }
              ),
              j === De.RELATED_CONCEPTS && /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                co,
                {
                  id: N.conceptId.toString(),
                  onChangeConcept: y,
                  onClickConcept: le,
                  onSelectConcept: v,
                  selectedConcepts: R,
                  viewMode: i
                }
              ) }),
              j === De.HIERARCHY && /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                Kt,
                {
                  id: N.conceptId.toString(),
                  onChangeConcept: y,
                  onClickConcept: le,
                  onSelectConcept: v,
                  selectedConcepts: R,
                  viewMode: i
                }
              ) }),
              j === De.NATIVE_HIERARCHY && /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                Kt,
                {
                  id: N.conceptId.toString(),
                  onChangeConcept: y,
                  onClickConcept: le,
                  onSelectConcept: v,
                  selectedConcepts: R,
                  viewMode: i,
                  isNativeHierarchy: !0
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}), Io = Q.div`
  display: flex;
  padding: 8px 0;
  justify-content: flex-end;
`, st = Q.label`
  display: flex;
  align-items: center;
  color: ${({ theme: t }) => t.palette.textColor.primary};
  font-size: 15px;
  :not(:last-of-type) {
    margin-right: 10px;
  }
  .app-checkbox {
    margin: 0 8px;
  }
`, Xt = ({
  onSelect: t,
  state: n,
  setState: s,
  isConcept: a
}) => {
  const [r, d] = U(!1), [C, h] = U(!1), [l, i] = U(!1), [c, u] = U(!1);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(_, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      qn,
      {
        data: n,
        enableDownload: !1,
        onChange: s,
        height: 300
      }
    ) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: !a && /* @__PURE__ */ e.jsxs(Io, { children: [
      /* @__PURE__ */ e.jsxs(st, { htmlFor: "excluded", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            checked: r,
            onChange: (o) => d(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "excluded"
          }
        ),
        "Excluded"
      ] }),
      /* @__PURE__ */ e.jsxs(st, { htmlFor: "descendants", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            checked: C,
            onChange: (o) => h(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "descendants"
          }
        ),
        "Descendants"
      ] }),
      /* @__PURE__ */ e.jsxs(st, { htmlFor: "mapped", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            checked: l,
            onChange: (o) => i(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "mapped"
          }
        ),
        "Mapped"
      ] }),
      /* @__PURE__ */ e.jsxs(st, { htmlFor: "hierarchy", children: [
        /* @__PURE__ */ e.jsx(
          re,
          {
            checked: c,
            onChange: (o) => u(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "hierarchy"
          }
        ),
        "Hierarchy"
      ] })
    ] }) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, textAlign: "right", children: /* @__PURE__ */ e.jsx(
      ae,
      {
        disabled: n.length == 0,
        onClick: () => t({
          excluded: r,
          descendants: C,
          mapped: l,
          hierarchy: c
        }),
        name: "addToCOnceptSet",
        variant: "contained",
        color: "success",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "submit" }),
        children: "Check concepts"
      }
    ) })
  ] }) });
}, Ro = {
  entityNavigationPanel: (t) => [
    {
      value: Se.CONCEPT_IDENTIFIERS,
      title: "Concept Identifiers",
      onTabClick: t
    },
    {
      value: Se.SOURCE_CODES,
      title: "Source codes",
      onTabClick: t
    }
  ],
  identifiers: {
    fetch: pn,
    parse: Bn
  },
  sourceCodes: {
    fetch: Cn,
    parse: rn
  }
}, Oo = (t) => {
  const n = t.split(",").map((r) => r.trim()), s = [], a = [];
  return n.forEach((r) => {
    /^\d+$/.test(r) ? s.push(r) : a.push(r);
  }), { numbers: s, others: a };
}, bo = (t, n) => {
  switch (t) {
    case Se.CONCEPT_IDENTIFIERS:
      return {
        getMethod: pn,
        ids: n.identifiers,
        type: ze.IDENTIFIERS
      };
    case Se.SOURCE_CODES:
      return {
        getMethod: Cn,
        ids: n.sourceCodes,
        type: ze.SOURCE_CODES
      };
  }
}, No = ({
  type: t,
  ids: n,
  extendOptions: s = {},
  hasHierarchy: a,
  onSubmit: r
}) => {
  const [d, C] = U([]), [h, l] = U(m.INITIAL), [i, c] = U(""), [u, o] = U(!1), E = bo(t, n), {
    selectedConcepts: T,
    detectSelectedAction: x,
    updateSelectedConceptBulk: p,
    init: O
  } = xe(), N = !Object.keys(T).length, A = (I) => {
    p(Array.isArray(I) ? I : [I]);
  }, j = () => {
    l(m.IN_PROGRESS);
    const I = t == Se.CONCEPT_IDENTIFIERS ? Oo(E.ids) : rn(E.ids);
    E.getMethod(
      t == Se.CONCEPT_IDENTIFIERS ? I.numbers : I
    ).then((R) => {
      if (t == Se.SOURCE_CODES) {
        const z = new Set(
          R.content.map(($) => $.CONCEPT_CODE.toUpperCase())
        ), k = I.filter(
          ($) => !z.has($.toUpperCase())
        );
        c(k.join(", "));
      }
      if (t == Se.CONCEPT_IDENTIFIERS) {
        const z = new Set(
          R.content.map(($) => $.CONCEPT_ID.toString())
        ), k = [...I.numbers, ...I.others].filter(
          ($) => !z.has($)
        );
        c(k.join(", "));
      }
      const y = R.content.map(
        (z) => {
          const k = ve(
            z,
            s
          );
          return k.concept.STANDARD_CONCEPT == "S" || k.concept.STANDARD_CONCEPT == "C" ? {
            ...k,
            hierarchy: !1
          } : {
            ...k,
            mapped: !1,
            descendants: !1
          };
        }
      );
      C(y);
    }).finally(() => l(m.SUCCESS));
  }, b = B(() => {
    o(!0), navigator.clipboard.writeText(i), Vn(() => o(!1), 2e3)();
  }, [i]), P = () => {
    Qn(
      i,
      "Missing identifiers.txt",
      Kn.APPLICATION_TEXT
    );
  }, f = B((I, R) => {
    const y = Te(I);
    x(y, R);
  }, []);
  return W(() => {
    j();
  }, []), /* @__PURE__ */ e.jsxs(_, { container: !0, children: [
    i && /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsxs(
      ut,
      {
        severity: "warning",
        action: /* @__PURE__ */ e.jsxs(
          F,
          {
            className: "actions-container",
            sx: {
              display: "flex",
              ".actions-container__button": {
                borderRadius: 0.5,
                p: 0.5,
                ml: 1
              }
            },
            children: [
              /* @__PURE__ */ e.jsx(be, { text: "Copy identifiers", width: 130, children: /* @__PURE__ */ e.jsx(
                ft,
                {
                  onClick: b,
                  className: "actions-container__button",
                  name: "copyToClipboard",
                  children: /* @__PURE__ */ e.jsx(
                    be,
                    {
                      text: "Identifiers copied to clipboard!",
                      controlled: !0,
                      show: u,
                      width: 130,
                      children: /* @__PURE__ */ e.jsx(
                        te,
                        {
                          iconName: "copy",
                          sx: { fontSize: 15 },
                          name: "Copy to clipboard"
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ e.jsx(be, { text: "Download identifiers", width: 130, children: /* @__PURE__ */ e.jsx(
                ft,
                {
                  onClick: P,
                  className: "actions-container__button",
                  name: "downloadFile",
                  children: /* @__PURE__ */ e.jsx(
                    te,
                    {
                      iconName: "download",
                      sx: { fontSize: 15 },
                      name: "Download as file"
                    }
                  )
                }
              ) })
            ]
          }
        ),
        children: [
          "Following identifiers were not found: ",
          /* @__PURE__ */ e.jsx("b", { children: i })
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      ue,
      {
        variant: "uncontrolled",
        storageKey: "concept-import",
        title: "Check concepts",
        showFilterToggle: !0,
        enableRowSelection: !0,
        hasDomainAndVocabulary: !0,
        hasRcDrc: !0,
        data: d,
        getRowId: (I) => String(I.conceptId),
        onRowSelect: f,
        reloadData: j,
        onEdit: A,
        onSelectAll: O,
        selectedConcepts: T,
        status: h,
        noGaps: !0,
        enableFiltering: !0,
        hasRcDrcSelect: !0,
        hasHierarchy: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, textAlign: "right", children: /* @__PURE__ */ e.jsx(
      ae,
      {
        onClick: () => r(T),
        name: "addToCOnceptSet",
        variant: "contained",
        color: "success",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "submit" }),
        disabled: N,
        children: "Add to concept set"
      }
    ) })
  ] });
}, fn = (t) => {
  const { onFind: n, onClose: s, isConcept: a, hasHierarchy: r } = t, [d, C] = U(
    Se.CONCEPT_IDENTIFIERS
  ), [h, l] = U(), {
    checkState: i,
    identifiers: c,
    sourceCodes: u,
    objectExtendConcepts: o,
    isCompleteDownload: E,
    updateIds: T,
    switchCheckMode: x,
    addConcepts: p
  } = _o(), O = (A) => {
    x(!0), l(A);
  }, N = K(() => Ro.entityNavigationPanel(C), []);
  return W(() => {
    E && (n(o), s());
  }, [E]), /* @__PURE__ */ e.jsx(_, { container: !0, children: i ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(je, { elevation: 3, sx: { zIndex: 2, px: 2, py: 1, width: "100%" }, children: /* @__PURE__ */ e.jsxs(
      ae,
      {
        onClick: () => x(!1),
        variant: "text",
        size: "medium",
        children: [
          "<",
          " Back to import"
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(je, { elevation: 0, sx: { p: 2 }, children: /* @__PURE__ */ e.jsx(
      No,
      {
        type: d,
        ids: { identifiers: c, sourceCodes: u },
        extendOptions: h,
        onSubmit: p,
        hasHierarchy: r
      }
    ) }) })
  ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      je,
      {
        elevation: 3,
        sx: { zIndex: 2, px: 2, width: "100%", borderRadius: 0 },
        children: /* @__PURE__ */ e.jsx(dn, { tabs: N, active: d })
      }
    ),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsxs(je, { elevation: 3, sx: { p: 2 }, children: [
      d == Se.CONCEPT_IDENTIFIERS && /* @__PURE__ */ e.jsx(
        Xt,
        {
          onSelect: O,
          state: c,
          setState: (A) => {
            T(ze.IDENTIFIERS, A);
          },
          isConcept: a
        }
      ),
      d == Se.SOURCE_CODES && /* @__PURE__ */ e.jsx(
        Xt,
        {
          onSelect: O,
          state: u,
          setState: (A) => {
            T(ze.SOURCE_CODES, A);
          },
          isConcept: a
        }
      )
    ] }) })
  ] }) });
};
Q.div``;
Q.div`
  padding: 2px 15px;
`;
Q(ln)`
  height: 40px;
  font-size: 12px;
  .selected-title {
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    text-decoration: underline;
    padding-right: 5px;
  }
  .selected-count {
    background: #e1ecf3;
    width: 23px;
    display: inline-block;
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    padding: 4px 2px;
  }
`;
Q.div`
  padding: 5px 15px;
`;
const jo = Q(
  _
)`
  border-bottom: 1px solid ${({ theme: t }) => t.palette.borderColor.main};
  background: #fff;
`, yo = fe((t) => {
  const { objectConcepts: n, onFind: s, onClose: a, domainId: r, standardConcept: d } = t, {
    searchData: C,
    pageCount: h,
    pageSize: l,
    status: i,
    totalElements: c,
    searchParams: { pageNumber: u, searchFilters: o },
    search: E,
    updateQuery: T
  } = wt(!0, r, d), [x, p] = U(!0), { selectedConcepts: O, detectSelectedAction: N, clear: A, init: j } = xe(n), b = () => {
    s(O), a == null || a();
  }, P = (R) => {
    T(R);
  };
  W(() => {
    p(!1);
  }, [o]);
  const f = B((R, y) => {
    const z = Te(R);
    N(z, y);
  }, []), I = Object.keys(O).length;
  return /* @__PURE__ */ e.jsxs(_, { container: !0, children: [
    /* @__PURE__ */ e.jsx(
      Pt,
      {
        onAdd: b,
        onClear: () => {
          A();
        },
        selectedConceptsCount: I,
        buttonText: "Add selected concepts",
        width: window.innerWidth - 250 + "px"
      }
    ),
    /* @__PURE__ */ e.jsx(
      jo,
      {
        item: !0,
        xs: 12,
        p: 2,
        className: "search-query-container",
        children: /* @__PURE__ */ e.jsx(xn, { onFind: P, dense: !0 })
      }
    ),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, p: 2, pb: I ? 8 : 2, children: /* @__PURE__ */ e.jsx(Qe, { children: !x && /* @__PURE__ */ e.jsx(
      ue,
      {
        variant: "controlled",
        storageKey: "search-concepts-widget",
        data: C,
        pageCount: h,
        pageSize: l,
        fetchData: E,
        pageIndex: u,
        status: i,
        totalElements: c,
        onSelectAll: j,
        getRowId: (R) => String(R.conceptId),
        selectedConcepts: O,
        onRowSelect: f,
        title: "All concepts",
        hasRcDrc: !0,
        hasRcDrcSelect: !0,
        enableRowSelection: !0,
        hasHierarchy: !1,
        outlined: !0
      }
    ) }) })
  ] });
}), Do = Q.div`
  /* padding-top: 0px; */
  .search-query-container {
    background-color: white;
    padding: 16px;
    box-shadow: ${({ theme: t }) => t.customShadows[2]};
  }
`, Ao = fe((t) => {
  const {
    onClose: n,
    onFind: s,
    subModules: a,
    vocabularyMode: r,
    path: d,
    typeContainer: C,
    parentId: h,
    viewMode: l
  } = t, i = Ge(), c = Je(), u = "/modal", o = c.pathname.indexOf(u), E = o !== -1 ? c.pathname.slice(0, o) || "/" : c.pathname || "/", [T, x] = U(), p = (() => {
    const j = c.pathname.match(/\/modal\/related\/([^/]+)/);
    return j == null ? void 0 : j[1];
  })(), O = (j) => {
    x(j), i(
      `${E}${u}/related/${j.conceptId}${c.search || ""}`
    );
  }, N = () => {
    x(null), i(`${E}${u}${c.search || ""}`, {
      replace: !0
    });
  }, A = (j) => {
    s(j), n();
  };
  return /* @__PURE__ */ e.jsx(_, { container: !0, children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: p ? /* @__PURE__ */ e.jsx(
    mt,
    {
      entryConcept: T,
      conceptId: p,
      onClose: n,
      pureClose: N,
      onFind: s,
      subModules: a,
      onSearchHandler: N,
      vocabularyMode: r,
      path: d,
      typeContainer: C,
      parentId: h,
      viewMode: l
    }
  ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(bt, { onClose: n, children: "Search" }),
    /* @__PURE__ */ e.jsx(Do, { children: /* @__PURE__ */ e.jsx(
      _n,
      {
        onRowClickAction: O,
        onSubmitAction: A,
        draftSelectedConceptsCount: void 0,
        openSelectedArea: void 0,
        vocabularyMode: !1,
        showOutlet: !1,
        replaceSearchParams: !0
      }
    ) })
  ] }) }) });
}), Po = /* @__PURE__ */ new Set([
  "fullSearch",
  "advancedSearch",
  "pageNumber"
]), vo = fe(
  (t) => {
    var Re, we, H;
    const {
      concepts: n,
      onChange: s,
      vocabularyMode: a,
      subModules: r,
      viewMode: d,
      typeContainer: C,
      parentId: h,
      mode: l
    } = t, { openModal: i, closeModal: c } = Rt(on), u = Ge(), o = Je(), E = "/modal", T = K(() => {
      const L = o.pathname.indexOf(E);
      return L !== -1 ? o.pathname.slice(0, L) || "/" : o.pathname || "/";
    }, [o.pathname]), x = K(
      () => o.pathname.includes(E),
      [o.pathname]
    ), p = B(
      (L) => {
        const J = T.endsWith("/") ? T.slice(0, -1) : T, he = L ? `/${L.replace(/^\/+/, "")}` : "";
        u(
          `${J || ""}${E}${he}${o.search || ""}`
        );
      },
      [T, o.search, u]
    ), {
      objectConcepts: O,
      reinitialConcepts: N,
      createConcepts: A,
      removeConcepts: j,
      updateConceptsBulk: b,
      status: P,
      updateStatus: f,
      reloadConceptData: I
    } = uo(n, l), { selectedConcepts: R, detectSelectedAction: y, init: z, clear: k } = xe({}, "id"), $ = (L) => {
      A(L);
    }, Y = () => {
      i(
        () => /* @__PURE__ */ e.jsx(fn, { onFind: $, onClose: c }),
        "Import concepts",
        {
          onClose: c,
          closeOnClickOutside: !0
        }
      );
    }, oe = ({
      updated: L,
      deleted: J
    }) => {
      b(Object.values(L)), j(J), c();
    }, ce = () => {
      i(
        () => /* @__PURE__ */ e.jsx(
          Hs,
          {
            items: O,
            onUpdate: oe
          }
        ),
        "Convert concepts",
        {
          onClose: c,
          closeOnClickOutside: !0
        }
      );
    }, le = () => {
      p();
    }, D = () => {
      i(
        () => /* @__PURE__ */ e.jsx(
          Ys,
          {
            items: O,
            onClose: c,
            onOverwriteConceptSet: N,
            subModules: r
          }
        ),
        "Concept set optimization",
        {
          onClose: c,
          closeOnClickOutside: !0
        }
      );
    }, v = (L) => {
      localStorage.setItem(
        "currentConceptSetItem",
        String(L.original.conceptId)
      ), p(`related/${L.original.conceptId}`);
    }, S = (L) => {
      const he = (Array.isArray(L) ? L : [L]).reduce((ke, Rn) => {
        const { row: kt, columnId: On, value: bn } = Rn;
        return ke[kt.id] = { ...kt, [On]: bn }, ke;
      }, {});
      b(Object.values(he));
    }, g = () => {
      j(R), k();
    }, w = B((L, J) => {
      const he = Te(L, {}, "id");
      y(he, J);
    }, []), G = B((L) => {
      const J = new URLSearchParams(L);
      Array.from(J.keys()).forEach((ke) => {
        (Po.has(ke) || ke.startsWith("filter.")) && J.delete(ke);
      });
      const he = J.toString();
      return he ? `?${he}` : "";
    }, []), M = () => {
      u(
        `${T}${G(
          o.search || ""
        )}`,
        { replace: !0 }
      );
    };
    W(() => {
      n && !Me(O, n) && N(n);
    }, [n]), W(() => {
      s(O);
    }, [O]);
    const q = (Re = Object.keys(R)) == null ? void 0 : Re.length, pe = (we = Object.keys(O)) == null ? void 0 : we.length, Ie = "Concept Set Expression is a `formula`, that allows to present large concept lists in a more compact way with the help of features like Exclude, Descendants, Mapped and Hierarchy. Hover over the corresponding icons in the table for detailed tooltip.", X = a ? void 0 : /* @__PURE__ */ e.jsx(be, { text: Ie, placement: "bottom", width: 420, children: /* @__PURE__ */ e.jsxs(mn, { children: [
      /* @__PURE__ */ e.jsx(At, {}),
      /* @__PURE__ */ e.jsx("span", { children: Ie })
    ] }) }), Ce = (H = Object.values(O)) == null ? void 0 : H.some(
      (L) => {
        var J, he;
        return ((J = L == null ? void 0 : L.concept) == null ? void 0 : J.STANDARD_CONCEPT) !== "S" && ((he = L == null ? void 0 : L.concept) == null ? void 0 : he.STANDARD_CONCEPT) !== "C";
      }
    );
    return /* @__PURE__ */ e.jsxs(_, { container: !0, children: [
      /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        ue,
        {
          variant: "uncontrolled",
          storageKey: "concept-expression",
          hiddenColumns: {
            RECORD_COUNT: !1,
            DESCENDANT_RECORD_COUNT: !1,
            PERSON_COUNT: !1,
            DESCENDANT_PERSON_COUNT: !1
          },
          filtersDefaultClosed: !0,
          showFilterToggle: !0,
          hasHierarchy: !0,
          enableRowSelection: !d,
          disableEdit: d,
          disabled: f === m.IN_PROGRESS,
          title: a ? "All selected concepts" : "All concept set items",
          headerInfo: X,
          data: Object.values(O),
          getRowId: (L) => L.id,
          selectedConcepts: R,
          onRowSelect: w,
          onEdit: S,
          onSelectAll: z,
          onRowClick: v,
          reloadData: I,
          status: P,
          hasRcDrcSelect: !0,
          outlined: !0,
          enableFiltering: !0,
          customActions: !d && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(
              _e,
              {
                iconName: "delete",
                title: "Delete",
                color: "error",
                onClick: g,
                name: "delete-selected",
                disabled: q < 1,
                count: q,
                tooltipText: "Delete"
              }
            ),
            !a && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                _e,
                {
                  iconName: "import",
                  title: "Import",
                  color: "default",
                  onClick: Y,
                  name: "import-codes",
                  tooltipText: "Import"
                }
              ),
              /* @__PURE__ */ e.jsx(
                _e,
                {
                  onClick: ce,
                  color: "default",
                  iconName: "reload",
                  title: "Convert",
                  tooltipText: Ce ? "Convert non-standard to standard" : "Nothing to convert",
                  disabled: !Ce
                }
              ),
              l !== "embedded" && /* @__PURE__ */ e.jsx(
                _e,
                {
                  iconName: "optimize",
                  title: "Optimize",
                  color: "default",
                  onClick: D,
                  name: "optimize-codes",
                  tooltipText: "Optimize",
                  disabled: !pe
                }
              ),
              /* @__PURE__ */ e.jsx(
                pt,
                {
                  iconName: "add",
                  title: "Add",
                  color: "success",
                  onClick: le,
                  name: "add-from-vocab",
                  tooltipText: "Add"
                }
              )
            ] })
          ] })
        }
      ) }),
      x && /* @__PURE__ */ e.jsx(We, { open: !0, onClose: M, children: /* @__PURE__ */ e.jsx(
        Ao,
        {
          onFind: A,
          subModules: r,
          onClose: M,
          vocabularyMode: !1,
          path: T.replace(/^\/+/, ""),
          typeContainer: C,
          parentId: h,
          viewMode: d
        }
      ) })
    ] });
  }
), Zt = (t) => {
  const {
    // concepts: objectConcepts, - not used
    subModules: n,
    onChange: s,
    method: a,
    filtersMethod: r,
    onFinish: d,
    path: C,
    viewMode: h,
    listType: l
  } = t, {
    fetchIncluded: i,
    status: c,
    pageCount: u,
    pageNumber: o,
    pageSize: E,
    totalElements: T,
    includedItems: x,
    filters: p,
    filtersForm: O,
    filtersStatus: N,
    updateFilters: A
  } = So({ get: a, getFilters: r }, l), {
    selectedConcepts: j,
    detectSelectedAction: b,
    updateSelectedConcept: P,
    init: f
  } = xe(), I = Ge(), R = Je(), y = "/modal", z = R.pathname.indexOf(y), k = z !== -1 ? R.pathname.slice(0, z) || "/" : R.pathname || "/", $ = (M) => {
    I(
      `${k}${y}/related/${M.original.conceptId}${R.search || ""}`
    );
  }, Y = () => {
    oe(j);
  }, oe = (M) => {
    s(Tt(M)), d();
  }, ce = (M) => {
    const q = {
      ...j[M.row.conceptId],
      [M.columnId]: M.value
    };
    P(q);
  }, { otherFilters: le, searchFilter: D } = Ze(
    p,
    "fullSearch"
  ), v = B((M, q) => {
    const pe = Te(M);
    b(pe, q);
  }, []), S = Object.keys(j).length, g = Object.values(O).some(
    (M) => (M == null ? void 0 : M.length) > 0
  ), w = l === Ve.INCLUDED_CONCEPTS ? "Included concepts is a final resolved list of concepts, which are used to query the database (concept_id or source_concept_id field in event tables)." : "All included concepts and implicitly included (via maps_to relationship) source codes.", G = /* @__PURE__ */ e.jsx(be, { text: w, placement: "bottom", width: 420, children: /* @__PURE__ */ e.jsxs(mn, { children: [
    /* @__PURE__ */ e.jsx(At, {}),
    /* @__PURE__ */ e.jsx("span", { children: w })
  ] }) });
  return /* @__PURE__ */ e.jsxs(_, { container: !0, children: [
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      ue,
      {
        title: l === Ve.INCLUDED_CONCEPTS ? "All included concepts" : "Included source codes",
        headerInfo: G,
        storageKey: l === Ve.INCLUDED_CONCEPTS ? "concept-set-included" : "concept-set-source-codes",
        disableEdit: !0,
        hasHierarchy: !1,
        enableRowSelection: !h,
        data: x,
        pageCount: u,
        pageSize: E,
        pageIndex: o,
        totalElements: T,
        fetchData: i,
        getRowId: (M) => String(M.conceptId),
        selectedConcepts: j,
        onRowSelect: v,
        onEdit: ce,
        onSelectAll: f,
        onRowClick: $,
        status: c,
        hasRcDrcSelect: !0,
        outlined: !0,
        variant: "controlled",
        hasFilters: g,
        showFilterToggle: !0,
        filtersDefaultClosed: !0,
        searchComponent: D && /* @__PURE__ */ e.jsx(
          Et,
          {
            ...D,
            value: O == null ? void 0 : O[D == null ? void 0 : D.name],
            onChange: (M) => A({ [D == null ? void 0 : D.name]: M })
          }
        ),
        customActions: !h && /* @__PURE__ */ e.jsxs(
          ae,
          {
            disabled: !S,
            onClick: Y,
            color: "info",
            variant: "contained",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
            name: "add-to-concept-set",
            sx: { ml: 2 },
            children: [
              "Add to concept set",
              /* @__PURE__ */ e.jsx(Xn, { sx: { ml: 1 }, dense: !0, inverted: !0, disabled: !S, children: S })
            ]
          }
        ),
        children: /* @__PURE__ */ e.jsx(
          Ke,
          {
            showLabel: !0,
            filters: le,
            value: O,
            onChange: (M, q) => {
              const pe = { [M]: q };
              A(pe);
            },
            isLoading: N === m.IN_PROGRESS,
            isReloading: N === m.IN_PROGRESS_RELOAD
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(un, { children: /* @__PURE__ */ e.jsx(
      ot,
      {
        path: "modal/related/:conceptId",
        element: /* @__PURE__ */ e.jsx(
          We,
          {
            open: !0,
            onClose: () => {
              I(`${k}${R.search || ""}`);
            },
            children: /* @__PURE__ */ e.jsx(
              mt,
              {
                subModules: n,
                onClose: () => {
                  I(`${k}${R.search || ""}`);
                },
                onFind: oe,
                vocabularyMode: !1,
                path: C,
                viewMode: h
              }
            )
          }
        )
      }
    ) })
  ] });
}, wo = fe((t) => {
  const { onFind: n, domainId: s, standardConcept: a } = t, { openModal: r, closeModal: d } = Rt(on), C = (i) => {
    const c = Object.keys(i).map(
      (u) => i[u].concept
    );
    n(c);
  }, h = () => {
    r(
      () => /* @__PURE__ */ e.jsx(
        yo,
        {
          objectConcepts: {},
          onFind: C,
          domainId: s,
          standardConcept: a,
          onClose: d
        }
      ),
      "Add concepts",
      {
        onClose: d,
        closeOnClickOutside: !0
      }
    );
  }, l = () => {
    r(
      () => /* @__PURE__ */ e.jsx(
        fn,
        {
          onFind: C,
          onClose: d,
          isConcept: !0,
          hasHierarchy: !1
        }
      ),
      "Import concepts",
      {
        onClose: d,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(_, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(_, { item: !0, children: /* @__PURE__ */ e.jsx(
      ae,
      {
        onClick: h,
        fullWidth: !1,
        variant: "outlined",
        name: "addConcept",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
        children: "Add"
      }
    ) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, children: /* @__PURE__ */ e.jsx(
      ae,
      {
        onClick: l,
        fullWidth: !1,
        variant: "outlined",
        name: "importConcept",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "import" }),
        children: "Import"
      }
    ) })
  ] }) });
});
function Tn(t, n, s) {
  const [a, r] = U(
    s ?? Ye.INITIAL
  ), [d, C] = U(
    m.INITIAL
  ), [h, l] = U(
    m.INITIAL
  ), [i, c] = U({
    prompt: "",
    items: [],
    domain: [],
    vocabulary: [],
    standard: []
  }), u = async (E) => {
    C(m.IN_PROGRESS);
    try {
      await ms(t, E), C(m.SUCCESS);
    } catch (T) {
      console.error(T);
    }
  }, o = B(async () => {
    l(m.IN_PROGRESS);
    try {
      const E = await xs(t);
      c(E), l(m.SUCCESS);
    } catch (E) {
      console.error(E), l(m.ERROR);
    }
  }, [t]);
  return W(() => {
    s !== void 0 && r(s);
  }, [s]), W(() => {
    a === Ye.DONE && o();
  }, [a, o]), {
    suggestionResult: i,
    suggestionStatus: a,
    suggestionResultStatus: h,
    createSuggestionStatus: d,
    getAiSuggestion: u
  };
}
const ko = (t) => {
  if (!t) return [];
  try {
    const n = JSON.parse(t);
    return Array.isArray(n) ? n : [];
  } catch {
    return [];
  }
}, Lo = (t) => {
  var a;
  const n = (t == null ? void 0 : t.conceptId) ?? ((a = t == null ? void 0 : t.concept) == null ? void 0 : a.CONCEPT_ID), s = yt();
  return !t || !n || !(t != null && t.concept) ? null : {
    id: s,
    conceptId: Number(n),
    concept: t.concept,
    descendants: !!t.descendants,
    mapped: !!t.mapped,
    excluded: !!t.excluded,
    hierarchy: !!t.hierarchy
  };
}, Fo = ({
  concepts: t,
  viewMode: n,
  id: s,
  onChange: a,
  onFinish: r,
  suggestionStatus: d,
  delta: C
}) => {
  const { suggestionResult: h, suggestionResultStatus: l, suggestionStatus: i } = Tn(s, C, d), [c, u] = U(!0), [o, E] = U({ textWrap: !1 }), { selectedConcepts: T, detectSelectedAction: x, updateSelectedConcept: p } = xe({}, "id"), O = (D) => {
    const S = {
      ...T[D.row.id] || T[D.row.conceptId] || D.row,
      [D.columnId]: D.value
    };
    p(S);
  }, N = B((D, v) => {
    const S = Te(D, {}, "id");
    x(S, v);
  }, []), A = (D) => {
    const v = Object.values(D).reduce((S, g) => {
      const w = Lo(g);
      return w && (S[w.id] = w), S;
    }, {});
    a == null || a(v), r == null || r();
  }, j = () => {
    A(T);
  }, b = K(() => {
    const D = /* @__PURE__ */ new Set();
    return Object.entries(t || {}).forEach(([v, S]) => {
      const g = S;
      D.add(String((g == null ? void 0 : g.conceptId) ?? (g == null ? void 0 : g.id) ?? v));
    }), D;
  }, [t]), P = K(() => Object.entries((h == null ? void 0 : h.items) || {}).map(([D, v]) => {
    var M;
    const S = v, g = String(
      (S == null ? void 0 : S.conceptId) ?? ((M = S == null ? void 0 : S.concept) == null ? void 0 : M.CONCEPT_ID) ?? ""
    ), w = String((S == null ? void 0 : S.id) ?? D ?? g), G = !!(S != null && S.existed || g && b.has(g));
    return {
      ...S,
      id: w,
      existed: G,
      aiStudies: ko(S.description)
    };
  }), [h, b]), f = K(() => {
    const D = /* @__PURE__ */ new Map();
    return P.forEach((v) => {
      const S = v.aiStudies || [];
      if (S.length === 0) {
        const g = "no-article";
        D.has(g) || D.set(g, {
          id: g,
          study_name: "No article",
          study_link: "",
          concepts: []
        }), D.get(g).concepts.push({ ...v });
        return;
      }
      S.forEach((g) => {
        const w = g.study_link || g.study_name || "no-article";
        D.has(w) || D.set(w, {
          id: w,
          study_name: g.study_name || "Article",
          study_link: g.study_link || "",
          concepts: []
        }), D.get(w).concepts.push({
          ...v,
          aiStudyReasoning: g.reasoning
        });
      });
    }), Array.from(D.values()).map((v) => ({
      ...v,
      conceptsCount: v.concepts.length
    }));
  }, [P]), I = Object.keys(T).length, R = K(
    () => Object.keys(T).reduce((D, v) => (D[v] = !0, D), {}),
    [T]
  ), y = K(
    () => [
      {
        header: "Article",
        accessorKey: "study_name",
        id: "ARTICLE",
        size: 360,
        filterFn: (D, v, S) => {
          const g = ((S == null ? void 0 : S[0]) || "").toLowerCase();
          return [D.original.study_name, D.original.study_link].some(
            (w) => String(w || "").toLowerCase().includes(g)
          );
        },
        meta: {
          filterVariant: "value"
        },
        cell: ({ row: D }) => {
          const v = D.original.study_link, S = Gt(v), g = o.textWrap;
          return /* @__PURE__ */ e.jsxs(F, { sx: { maxWidth: "100%" }, children: [
            /* @__PURE__ */ e.jsx(
              se,
              {
                variant: "body2",
                title: D.original.study_name,
                sx: {
                  fontSize: 13,
                  whiteSpace: g ? "normal" : "nowrap",
                  overflow: g ? "visible" : "hidden",
                  textOverflow: g ? "clip" : "ellipsis",
                  wordBreak: g ? "break-word" : "normal"
                },
                children: D.original.study_name
              }
            ),
            v && /* @__PURE__ */ e.jsx(
              se,
              {
                variant: "body2",
                title: v,
                ...S ? {
                  component: "a",
                  href: v,
                  target: "_blank"
                } : {},
                sx: {
                  textDecoration: S ? "underline" : "none",
                  display: g ? "block" : "inline-flex",
                  fontSize: 12,
                  color: "text.secondary",
                  maxWidth: 520,
                  whiteSpace: g ? "normal" : "nowrap",
                  overflow: g ? "visible" : "hidden",
                  textOverflow: g ? "clip" : "ellipsis",
                  wordBreak: g ? "break-word" : "normal"
                },
                children: v
              }
            )
          ] });
        },
        sortingFn: "alphanumeric"
      },
      {
        header: "Concepts",
        accessorKey: "conceptsCount",
        id: "CONCEPTS_COUNT",
        size: 30,
        meta: {
          align: "center",
          headerAlign: "center"
        }
      }
    ],
    [o.textWrap]
  ), z = K(
    () => Sn(
      !0,
      !1,
      !1,
      !1,
      n,
      void 0
    ),
    [n]
  ), k = K(
    () => [
      ...z,
      {
        header: "Reasoning",
        accessorKey: "aiStudyReasoning",
        id: "AI_REASONING",
        size: 360,
        cell: ({ getValue: D }) => {
          const v = D();
          return /* @__PURE__ */ e.jsx(
            se,
            {
              variant: "body2",
              sx: {
                fontSize: 12,
                color: "text.secondary",
                lineHeight: 1.6
              },
              children: typeof v == "string" ? v : ""
            }
          );
        }
      }
    ],
    [z]
  ), $ = K(
    () => y.slice(),
    [y]
  ), Y = K(
    () => k.slice(),
    [k]
  ), oe = K(
    () => z.slice(),
    [z]
  ), ce = K(() => P.slice(), [P]), le = B(({ row: D }) => {
    const v = D.original, S = v.aiStudies || [];
    return S.length ? /* @__PURE__ */ e.jsx(
      F,
      {
        sx: {
          px: 3,
          py: 2,
          bgcolor: "backgroundColor.main",
          borderBottom: "1px solid",
          borderColor: "rgb(225, 229, 238)"
        },
        children: S.map((g, w) => {
          const G = g.study_link || "", M = g.study_name || G || "Article", q = Gt(G);
          return /* @__PURE__ */ e.jsxs(F, { mb: 2, children: [
            /* @__PURE__ */ e.jsxs(
              se,
              {
                variant: "body2",
                component: "div",
                sx: {
                  fontSize: 13,
                  fontWeight: 600,
                  lineHeight: 1.6,
                  "& a": {
                    color: "inherit"
                  }
                },
                children: [
                  "• ",
                  M,
                  G && " — ",
                  G && (q ? /* @__PURE__ */ e.jsx(
                    F,
                    {
                      component: "a",
                      href: G,
                      target: "_blank",
                      rel: "noreferrer",
                      sx: { textDecoration: "underline" },
                      children: G
                    }
                  ) : G)
                ]
              }
            ),
            g.reasoning && /* @__PURE__ */ e.jsx(
              se,
              {
                variant: "body2",
                sx: {
                  mt: 0.5,
                  ml: 2,
                  fontSize: 13,
                  fontStyle: "italic",
                  color: "text.secondary",
                  lineHeight: 1.6
                },
                children: g.reasoning
              }
            )
          ] }, `${v.id || v.conceptId}-${w}`);
        })
      }
    ) : null;
  }, []);
  return i === Ye.IN_PROGRESS ? /* @__PURE__ */ e.jsx(Dt, { children: /* @__PURE__ */ e.jsx(kn, { text: "Generating AI suggestions" }) }) : /* @__PURE__ */ e.jsx(_, { container: !0, children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
    Ee,
    {
      outlined: !0,
      title: /* @__PURE__ */ e.jsx(
        Le,
        {
          title: "AI suggested concepts",
          count: P.length,
          loading: l === m.IN_PROGRESS || l === m.IN_PROGRESS_RELOAD
        }
      ),
      actions: /* @__PURE__ */ e.jsxs(F, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ e.jsxs(
          F,
          {
            display: "flex",
            alignItems: "center",
            mr: 2,
            onClick: (D) => {
              D.stopPropagation();
            },
            children: [
              /* @__PURE__ */ e.jsx(
                se,
                {
                  variant: "body2",
                  sx: {
                    mr: 1,
                    whiteSpace: "nowrap",
                    opacity: c ? 0.7 : 1
                  },
                  children: "Group by Concept"
                }
              ),
              /* @__PURE__ */ e.jsx(F, { mr: 1, children: /* @__PURE__ */ e.jsx(
                sn,
                {
                  id: "group-by-article",
                  value: c,
                  checked: c,
                  onChange: () => {
                    u((D) => !D);
                  },
                  size: "small",
                  color: "info"
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                se,
                {
                  component: "label",
                  htmlFor: "group-by-article",
                  variant: "body2",
                  sx: {
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    opacity: c ? 1 : 0.7
                  },
                  children: "Group By Article"
                }
              )
            ]
          }
        ),
        !n && /* @__PURE__ */ e.jsxs(
          ae,
          {
            disabled: !I,
            onClick: j,
            color: "info",
            variant: "contained",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
            name: "add-to-concept-set",
            children: [
              "Add to concept set",
              /* @__PURE__ */ e.jsx(
                Ln,
                {
                  sx: { ml: 1 },
                  dense: !0,
                  inverted: !0,
                  disabled: !I,
                  children: I
                }
              )
            ]
          }
        )
      ] }),
      children: c ? /* @__PURE__ */ e.jsx(
        Ue,
        {
          variant: "uncontrolled",
          data: f,
          columns: $,
          settingsOptions: o,
          onSettingsChange: E,
          enableFiltering: !0,
          filtersDefaultClosed: !0,
          showFilterToggle: !0,
          loading: l === m.IN_PROGRESS || l === m.IN_PROGRESS_RELOAD,
          loadingMessage: "Loading AI suggested concepts...",
          noDataText: "No AI suggested concepts",
          isExpandable: !0,
          getRowCanExpand: (D) => {
            var v;
            return ((v = D.original.concepts) == null ? void 0 : v.length) > 0;
          },
          renderExpandedRow: ({ row: D }) => /* @__PURE__ */ e.jsx(
            _,
            {
              container: !0,
              width: "100%",
              bgcolor: "backgroundColor.main",
              borderBottom: "1px solid",
              borderColor: "rgb(225, 229, 238)",
              sx: {
                ".table-actions__container, .table-pagination__container": {
                  px: 1
                },
                ".table-row-expanded > td": {
                  padding: 0
                },
                ".disabled__table-row": {
                  pointerEvents: "all",
                  input: {
                    pointerEvents: "none"
                  }
                }
              },
              children: /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, px: 1, py: 1, children: /* @__PURE__ */ e.jsx(
                Ue,
                {
                  variant: "uncontrolled",
                  data: D.original.concepts,
                  columns: Y,
                  settingsOptions: o,
                  enableRowSelection: !0,
                  onRowSelect: N,
                  onEdit: O,
                  selectedRowIds: R,
                  disableRowSelect: (v) => v.original.existed === !0,
                  getRowId: (v) => {
                    const S = v;
                    return String(S.id ?? S.conceptId);
                  },
                  enableFiltering: !1,
                  hideSettings: !0,
                  pageSize: 10,
                  loading: !1,
                  noDataText: "No concepts for this article",
                  defaultSorting: { desc: !0, id: "STANDARD_CONCEPT" }
                }
              ) })
            }
          )
        }
      ) : /* @__PURE__ */ e.jsx(
        Ue,
        {
          variant: "uncontrolled",
          data: ce,
          columns: oe,
          settingsOptions: o,
          onSettingsChange: E,
          enableFiltering: !0,
          filtersDefaultClosed: !0,
          showFilterToggle: !0,
          enableRowSelection: !0,
          onRowSelect: N,
          onEdit: O,
          selectedRowIds: R,
          disableRowSelect: (D) => D.original.existed === !0,
          getRowId: (D) => {
            const v = D;
            return String(v.id ?? v.conceptId);
          },
          isExpandable: !0,
          getRowCanExpand: (D) => {
            var v;
            return !!((v = D.original.aiStudies) != null && v.length);
          },
          renderExpandedRow: le,
          loading: l === m.IN_PROGRESS || l === m.IN_PROGRESS_RELOAD,
          loadingMessage: "Loading AI suggested concepts...",
          noDataText: "No AI suggested concepts",
          defaultSorting: { desc: !0, id: "STANDARD_CONCEPT" }
        }
      )
    }
  ) }) });
}, gt = (t, n) => {
  var s;
  return typeof t != "string" ? t.name : ((s = n.find((a) => a.value === t)) == null ? void 0 : s.name) || t;
}, Uo = ({
  onClose: t,
  id: n,
  onFinish: s,
  suggestionStatus: a
}) => {
  var O, N, A, j, b, P;
  const { enqueueSnackbar: r } = ht(), {
    suggestionStatus: d,
    suggestionResultStatus: C,
    createSuggestionStatus: h,
    suggestionResult: l,
    getAiSuggestion: i
  } = Tn(n, void 0, a), [c, u] = U({
    prompt: (l == null ? void 0 : l.prompt) || "",
    domain: (l == null ? void 0 : l.domain) || [],
    standard: (l == null ? void 0 : l.standard) || [],
    vocabulary: (l == null ? void 0 : l.vocabulary) || []
  }), { options: o, status: E } = Un(), T = B((f) => {
    const { name: I, value: R } = f.target;
    u((y) => ({ ...y, [I]: R }));
  }, []), x = B(
    (f, I) => {
      u((R) => ({ ...R, [f]: I }));
    },
    []
  ), p = async () => {
    try {
      if (n && c.prompt)
        await i({
          prompt: c.prompt,
          domain: c.domain.map(
            (f) => typeof f == "string" ? f : f.value
          ),
          vocabulary: c.vocabulary.map(
            (f) => typeof f == "string" ? f : f.value
          ),
          standard: c.standard.map(
            (f) => typeof f == "string" ? f : f.value
          )
        });
      else
        throw new Error("Please, provide missing data");
      r({
        message: "Generation successfully started",
        variant: "success"
      }), s(), t();
    } catch {
      r({
        message: "Something went wrong",
        variant: "error"
      });
    }
  };
  return W(() => {
    l.prompt && u((f) => ({
      ...f,
      prompt: l.prompt,
      domain: (l == null ? void 0 : l.domain) || [],
      standard: (l == null ? void 0 : l.standard) || [],
      vocabulary: (l == null ? void 0 : l.vocabulary) || []
    }));
  }, [l.prompt]), C === m.IN_PROGRESS || C === m.INITIAL && d !== Ye.IN_PROGRESS && d != null ? /* @__PURE__ */ e.jsx(F, { textAlign: "center", mt: 4, children: /* @__PURE__ */ e.jsx(Ct, { color: "secondary" }) }) : /* @__PURE__ */ e.jsx(F, { p: 2, children: /* @__PURE__ */ e.jsx(Ee, { outlined: !0, elevated: !0, children: /* @__PURE__ */ e.jsxs(_, { container: !0, pb: 0.5, spacing: 2, children: [
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(tt, { name: "prompt", textLabel: "Prompt", required: !0, children: /* @__PURE__ */ e.jsx(
      Ot,
      {
        id: "prompt",
        name: "prompt",
        type: "text",
        size: "medium",
        value: c.prompt,
        placeholder: "Enter prompt for generation",
        onChange: T,
        fullWidth: !0,
        multiline: !0,
        minRows: 6,
        maxRows: 20
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(tt, { name: "domain", textLabel: "Domain", children: /* @__PURE__ */ e.jsx(
      Fe,
      {
        id: "domain",
        name: "domain",
        options: ((O = o == null ? void 0 : o.domains) == null ? void 0 : O.filter(
          (f) => {
            var I;
            return !((I = c.domain) != null && I.some(
              (R) => R.value === f.value
            ));
          }
        )) || [],
        value: c.domain,
        multiple: !0,
        placeholder: (N = c.domain) != null && N.length ? "" : "Any",
        onChange: (f, I) => {
          x("domain", I);
        },
        fullWidth: !0,
        isOptionEqualToValue: (f, I) => f.value === I,
        getOptionLabel: (f) => gt(f, (o == null ? void 0 : o.domains) || []),
        loading: E === m.IN_PROGRESS
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(tt, { name: "standard_concept", textLabel: "Standard Concept", children: /* @__PURE__ */ e.jsx(
      Fe,
      {
        id: "standard_concept",
        name: "standard_concept",
        options: ((A = o == null ? void 0 : o.standard_concepts) == null ? void 0 : A.filter(
          (f) => {
            var I;
            return !((I = c.standard) != null && I.some(
              (R) => R.value === f.value
            ));
          }
        )) || [],
        value: c.standard,
        placeholder: (j = c.standard) != null && j.length ? "" : "Any",
        multiple: !0,
        onChange: (f, I) => {
          x("standard", I);
        },
        fullWidth: !0,
        isOptionEqualToValue: (f, I) => f.value === I,
        getOptionLabel: (f) => gt(f, (o == null ? void 0 : o.standard_concepts) || []),
        loading: E === m.IN_PROGRESS
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(_, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(tt, { name: "vocabulary", textLabel: "Vocabulary", children: /* @__PURE__ */ e.jsx(
      Fe,
      {
        id: "vocabulary",
        name: "vocabulary",
        options: ((b = o == null ? void 0 : o.vocabularies) == null ? void 0 : b.filter(
          (f) => {
            var I;
            return !((I = c.vocabulary) != null && I.some(
              (R) => R.value === f.value
            ));
          }
        )) || [],
        value: c.vocabulary,
        multiple: !0,
        placeholder: (P = c.vocabulary) != null && P.length ? "" : "Any",
        onChange: (f, I) => {
          x("vocabulary", I);
        },
        fullWidth: !0,
        isOptionEqualToValue: (f, I) => f.value === I,
        getOptionLabel: (f) => gt(f, (o == null ? void 0 : o.vocabularies) || []),
        loading: E === m.IN_PROGRESS
      }
    ) }) }),
    /* @__PURE__ */ e.jsxs(_, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(qe, {}),
      /* @__PURE__ */ e.jsxs(
        F,
        {
          display: "flex",
          pt: 2,
          justifyContent: "end",
          sx: {
            "*:not(:first-of-type)": { marginLeft: 1 }
          },
          children: [
            /* @__PURE__ */ e.jsx(
              _e,
              {
                iconName: "close",
                title: "Cancel",
                color: "secondary",
                noCollapse: !0,
                onClick: t
              }
            ),
            /* @__PURE__ */ e.jsx(
              _e,
              {
                iconName: "submit",
                title: "Submit",
                color: "success",
                noCollapse: !0,
                disabled: !c.prompt || h === m.IN_PROGRESS || d === Ye.IN_PROGRESS,
                onClick: p,
                loading: h === m.IN_PROGRESS
              }
            )
          ]
        }
      )
    ] })
  ] }) }) });
}, Mo = fe((t) => {
  const { name: n, config: s, ...a } = t, {
    concept: r,
    selectedConcepts: d = {},
    onFind: C,
    onClose: h,
    onChange: l,
    onFinish: i,
    onAdd: c,
    onAddConcepts: u,
    concepts: o,
    conceptSetId: E,
    domainId: T,
    standardConcept: x,
    methodIncluded: p,
    filtersIncluded: O,
    vocabularyMode: N,
    outerUpdate: A,
    viewMode: j,
    versionId: b,
    typeContainer: P,
    parentId: f,
    mode: I,
    value: R,
    placeholder: y,
    showSelectAll: z,
    suggestionStatus: k,
    delta: $,
    ...Y
  } = s;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n === "vocabulary-concept" && /* @__PURE__ */ e.jsx(
      mt,
      {
        ...a,
        entryConcept: r,
        onClose: h,
        onFind: C,
        vocabularyMode: N,
        viewMode: j,
        typeContainer: P,
        parentId: f
      }
    ),
    n === "expression-concepts" && /* @__PURE__ */ e.jsx(
      vo,
      {
        ...a,
        onChange: l,
        concepts: o,
        outerUpdate: A,
        viewMode: j,
        typeContainer: P,
        parentId: f,
        mode: I
      }
    ),
    n === "included-concepts" && /* @__PURE__ */ e.jsx(
      Zt,
      {
        ...a,
        ...Y,
        onChange: l,
        concepts: o,
        onFinish: i,
        method: p,
        filtersMethod: O,
        viewMode: j,
        conceptSetId: E,
        versionId: b,
        listType: Ve.INCLUDED_CONCEPTS
      }
    ),
    n === "included-concepts-source-codes" && /* @__PURE__ */ e.jsx(
      Zt,
      {
        ...a,
        ...Y,
        onChange: l,
        concepts: o,
        onFinish: i,
        method: p,
        filtersMethod: O,
        viewMode: j,
        conceptSetId: E,
        versionId: b,
        listType: Ve.INCLUDED_SOURCE_CODES
      }
    ),
    n === "add-import-concepts-widget" && /* @__PURE__ */ e.jsx(
      wo,
      {
        ...a,
        onFind: u,
        domainId: T,
        standardConcept: x
      }
    ),
    n === "add-concepts-widget" && /* @__PURE__ */ e.jsx(
      gs,
      {
        ...a,
        onAdd: u,
        domainId: T,
        standardConcept: x,
        value: R,
        standard: !0,
        placeholder: y,
        showSelectAll: z
      }
    ),
    n === "ai-suggested-concepts" && /* @__PURE__ */ e.jsx(
      Fo,
      {
        viewMode: j,
        id: E,
        concepts: o,
        onChange: l,
        onFinish: i,
        suggestionStatus: k,
        delta: $
      }
    ),
    n === "ai-suggest-dialog" && /* @__PURE__ */ e.jsx(
      Uo,
      {
        onClose: h,
        id: E,
        onFinish: i,
        suggestionStatus: k
      }
    )
  ] });
}), zo = {
  breadcrumbs: (t) => [
    {
      name: "Vocabulary",
      path: t
    }
  ]
}, Go = fe(() => {
  const t = Ge(), n = Je(), s = Zn(), { path: a, storage: r, subModules: d } = Rt(
    In
  ), { breadcrumbs: C } = zo, h = r, {
    selectedConcepts: l,
    detectSelectedAction: i,
    init: c,
    updateSelectedConceptBulk: u,
    clear: o
  } = xe((h == null ? void 0 : h.selectedElements) || {});
  W(() => {
    s(ss(C(a)));
  }, []);
  const E = ge.useCallback(
    (O) => i(
      Te(O, l)
    ),
    [l]
  ), T = () => {
    t("modal/selected");
  }, x = (O) => {
    t(`modal/related/${O.conceptId}`);
  }, p = () => {
    const O = n.state;
    if (O != null && O.closeTo) {
      t(O.closeTo, { replace: !0 });
      return;
    }
    t(`/${a}`);
  };
  return /* @__PURE__ */ e.jsx(_, { container: !0, px: 6, minHeight: "inherit", alignContent: "flex-start", children: /* @__PURE__ */ e.jsx(un, { children: /* @__PURE__ */ e.jsxs(
    ot,
    {
      path: "*",
      element: /* @__PURE__ */ e.jsx(
        _n,
        {
          onRowClickAction: x,
          onSubmitAction: E,
          vocabularyMode: !0,
          openSelectedArea: T,
          draftSelectedConceptsCount: Object.keys(l).length
        }
      ),
      children: [
        /* @__PURE__ */ e.jsx(
          ot,
          {
            path: "modal/related/:conceptId",
            element: /* @__PURE__ */ e.jsx(We, { open: !0, onClose: p, children: /* @__PURE__ */ e.jsx(
              mt,
              {
                onClose: p,
                subModules: d,
                vocabularyMode: !0,
                path: a,
                onFind: E
              }
            ) })
          }
        ),
        /* @__PURE__ */ e.jsx(
          ot,
          {
            path: "modal/selected",
            element: /* @__PURE__ */ e.jsx(We, { open: !0, onClose: p, children: /* @__PURE__ */ e.jsx(
              to,
              {
                onChange: u,
                onChangeBulk: c,
                concepts: l,
                subModules: d,
                pureClose: p,
                onClose: () => {
                  o(), p();
                },
                path: a
              }
            ) })
          }
        )
      ]
    }
  ) }) });
}), In = Nn(null), Ho = (t) => {
  const { path: n, title: s, name: a, initStorage: r, rootSettings: d } = t, [C, h] = U(d), [l, i] = U(!0);
  return W(() => {
    d || h({
      rootPath: n,
      rootTitle: s
    }), i(!1), document.title = "Prometheus - Vocabulary";
  }, []), l ? /* @__PURE__ */ e.jsx(Dt, { children: /* @__PURE__ */ e.jsx(Ct, { size: 32 }) }) : /* @__PURE__ */ e.jsx(In.Provider, { value: { ...t, rootSettings: C }, children: /* @__PURE__ */ e.jsx(Go, {}) });
}, ea = (t) => {
  const { type: n } = t;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    !n && /* @__PURE__ */ e.jsx(Ho, { ...t }),
    n === "component" && /* @__PURE__ */ e.jsx(Mo, { ...t })
  ] });
};
export {
  ea as Vocabulary
};
